window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function() {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString.split('&').filter(function(element) {
      return element.length;
    }).forEach(function(paramValue) {
      var splitted = paramValue.split('=');

      if (splitted.length > 1) {
        queryParams[splitted[0]] = splitted[1];
      } else {
        queryParams[splitted[0]] = true;
      }
    });

    return queryParams;
  },

  /**
   * Returns empty string or query string with '?' prefix
   *
   * @return (string)
   */
  getQueryString: function() {
    var queryString = location.search && location.search.substr(1) || '';

    // Add the '?' prefix if there is an actual query
    if (queryString.length) {
      queryString = '?' + queryString;
    }

    return queryString;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   * Will also remove the key if an empty value is passed in
   * See: https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {

    uri = uri || window.location.href;

    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
      if (uri.slice(-1) === '?') {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
    uri = uri || window.location.href;

    var rtn = uri.split("?")[0],
      param,
      params_arr = [],
      queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === parameterKeyToRemove) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length > 0) {
        rtn = rtn + "?" + params_arr.join("&");
      }
    }

    return rtn;
  },

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function() {
    return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function() {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition': 'transitionend',
      'OTransition': 'oTransitionEnd',
      'MozTransition': 'transitionend',
      'WebkitTransition': 'webkitTransitionEnd'
    };

    for (t in transitions) {
      if (el.style[t] !== undefined) {
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function() {
    var ua = navigator.userAgent,
      d = document.documentElement,
      classes = d.className,
      matches;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      classes += ' ua-ios';

      // Add class for version of iOS
      matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if (matches) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if (/Twitter/.test(ua)) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if (/CriOS/.test(ua)) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if (/Android/.test(ua)) {
      matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g, '_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if (/webOS|hpwOS/.test(ua)) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if (/SamsungBrowser/.test(ua)) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   * Reference - https://stackoverflow.com/a/7616484
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function(string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr = string.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();

    // Allows browser autofill to function properly
    $selects.on('change', function() {
      $(this).trigger('chosen:updated');
    });
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  /**
   * Pluralizes the unit for the nuber passed in.
   * Usage mirrors the Shopify "pluralize" string filter
   *
   * @param {Number} number
   * @param {String} singular
   * @param {String} plural
   * @return {String}
   */
  pluralize: function(number, singular, plural) {
    var output = '';

    number = parseInt(number);

    if (number == 1) {
      output = singular;
    }
    else {
      output = plural;
      if (typeof plural == "undefined") {
        output = singular + 's'; // last resort, turn singular into a plural
      }
    }
    return output;
  },

  refreshVideoPosters: function() {
    $('video').each(function() {
      var poster = $(this).closest('[data-video-poster]').attr('data-video-poster');
      poster && $(this).attr('poster', poster);
    });
  }

};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTables: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.addClass('table');
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Removes '.00' if found at the end of the string
   *
   * @param  {string} value - formatted price (see above)
   * @return {string} value - formatted value
   */
  function stripZeroCents(string) {
    return string.replace(/\.00$/, '');
  }

  return {
    formatMoney: formatMoney,
    stripZeroCents: stripZeroCents
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.variantOptionValueList = options.variantOptionValueList;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.hasMissingVariants = this.product.has_missing_variants;

    if ($(this.singleOptionSelector, this.$container).length) {
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    } else {
      $(this.originalSelectorId, this.$container).on('change', this._onOriginalSelectChange.bind(this));
    }
    this._getCurrentOptions();
    this._disableImpossibleVariants();
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element, i) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      this.currentOptions = slate.utils.compact(currentOptions);

      return this.currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      // If variant is *illegal*, select first legal variant.
      if (!variant) {
        variant = this._selectFirstLegalVariant(this.currentOptions[0]);
      }

      this._disableImpossibleVariants();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        product: this.product
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _onOriginalSelectChange: function() {
      var variantId = $(this.originalSelectorId, this.$container)[0].value;

      var variant = this.product.variants.filter(function(variant) {
        return variant.id == variantId;
      });

      variant = variant[0];

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        product: this.product
      });

      if (!variant) {
        return;
      }

      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },


    /**
     * Disables impossible variants, if there are variant permutations missing.
     * Note: This method assumes that the first variant option takes priority.
     *
     */
    _disableImpossibleVariants: function() {
      if (!this.hasMissingVariants || this.currentOptions.length <= 1) {
        return;
      }

      // Create empty arrays to house valid values for the other two options.
      var validValues = this._getValidOptionValues();

      // Loop over selectors, disabling options with invalid values.
      $(this.variantOptionValueList, this.$container).each(function(i, el) {
        if (i == 0) {
          return;
        }

        var $selector = $(el);
        var validValuesArr = validValues["option" + (i + 1)];

        $selector.find('input[type="radio"]').each(function(i, el) {
          $option = $(el);
          if (validValuesArr.indexOf($option.val()) == -1) {
            $option.attr('disabled', 'disabled');
          } else {
            $option.removeAttr('disabled');
          }
        });
      });
    },

    /**
     * Method to get the option values that are valid based on the value of option1.
     * @returns {Object} - Object that contains arrays of valid values for options 2 & 3.
     */
    _getValidOptionValues: function() {
      // Get first option value
      var optionValue1 = this.currentOptions[0].value;

      // Arrays of valid values
      var validValues = {
        option2: [],
        option3: []
      };

      // Loop over all variants, getting an array of valid values for the other option fields.
      this.product.variants.forEach(function(variant) {
        if (variant.option1 == optionValue1) {
          // TODO: DRY...
          var option2 = variant.option2;
          var option3 = variant.option3;

          if (option2 && validValues.option2.indexOf(option2) === -1) {
            validValues.option2.push(option2);
          }

          if (option3 && validValues.option3.indexOf(option3) === -1) {
            validValues.option3.push(option3);
          }
        }
      });

      return validValues;
    },

    /**
     * Selects the first legal variant
     * @param {Object} baseOption - option object {'index' : 'option1', 'value': 'foobar'} to use as the 'base' to select the other two.
     */
    _selectFirstLegalVariant: function(baseOption) {
      var optionValues = {};
      for (var i = 0; i < this.product.variants.length; i++) {
        var variant = this.product.variants[i];
        if (variant[baseOption.index] == baseOption.value) {
          optionValues = [
            variant.option1,
            variant.option2,
            variant.option3
          ]
          break;
        }
      }

      $(this.variantOptionValueList, this.$container).each(function(i, el) {
        const $radio = $(el).find('input[value="' + optionValues[i] + '"]')
        $radio.prop('checked', true);
        $radio.trigger('chosen:updated');
      });

      return variant;

    }
  });

  return Variants;
})();

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * This is a bare-bones but completely usable implementation of an AJAX enabled cart
 *
 * Usage: slate.AjaxCart.init(options);
 *
 * See the following list of stubbed / incomplete methods that need to be filled in
 *
 *   - AjaxCart.onOpenClick
 *   - AjaxCart.onCloseClick
 *   - AjaxCart.open
 *   - AjaxCart.close
 *   - AjaxCart.onItemAddFail
 *   - AjaxCart.buildCart
 *
 */

(function($, Handlebars, slate) {

  document.addEventListener('og-cart-updated', ev => {
    $(window).trigger('refresh.ajaxCart');
    ev.preventDefault();
  });

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

  /**
   * AJAX submit an 'add to cart' form
   *
   * @param {jQuery} $form - jQuery instance of the form
   * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
   */
  ShopifyAPI.addItemFromForm = function($form) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function() {
        if (ShopifyAPI && ShopifyAPI.getCart) {
          ShopifyAPI.getCart().then(function(data) {
            promise.resolve(data);
          });
        }
      },
      error: function() {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };
  /**
    * AJAX submit an 'add to cart' form
    *
    * @param {item} item data
    * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
    */
  ShopifyAPI.addItem = function(item) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: item,
      success: function() {
        ShopifyAPI.getCart().then(function(data) {
          promise.resolve(data);
        });
      },
      error: function() {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };

  /**
   * Retrieve a JSON respresentation of the users cart
   *
   * @return {Promise} - JSON cart
   */
  ShopifyAPI.getCart = function() {
    var promise = $.Deferred();

    var url = slate.utils.isThemeEditor() ? '/cart.js' : '/cart?view=json'; // Theme editor inserts HTML comments in custom templates and breaks JSON response

    $.ajax({
      type: 'get',
      url: url,
      success: function(data) {
        var cart = JSON.parse(data);
        promise.resolve(cart);
      },
      error: function() {
        promise.reject({
          message: 'Could not retrieve cart items'
        });
      }
    });

    return promise;
  };

  /**
   * Retrieve a JSON respresentation of the users cart
   *
   * @return {Promise} - JSON cart
   */
  ShopifyAPI.getProduct = function(handle) {
    return $.getJSON('/products/' + handle + '.js');
  };

  /**
   * Change the quantity of an item in the users cart
   *
   * @param {int} line - Cart line
   * @param {int} qty - New quantity of the variant
   * @return {Promise} - JSON cart
   */
  ShopifyAPI.changeLineItemQuantity = function(line, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&line=' + line
    });
  };

  /**
  * AJAX submit an 'add to cart' form.
  * Main difference with other add to cart functions is that this one doesn't return anything.
  * Also refresh and opens the Mini-Cart on success.
  *
  * @param {int} variantId - Product variant ID.
  * @param {int} quantity - Quantity of the variant.
  * @param {obj} properties - Properties to the cart item.
  *
  */
  ShopifyAPI.addToCart = function(variantId, quantity, properties) {
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/cart/add.js',
      data: {
        quantity: quantity,
        id: variantId,
        properties: properties,
      },
      success: function() {
        $(window).trigger('refresh.ajaxCart');
        $(window).trigger('open.ajaxCart');
      },
      error: function(e) {
        console.warn(e.responseJSON.description);
      }
    });
  }

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function() {

    var $window = $(window);
    var $body = $('body');

    var selectors = {
      sectionWrapper: '[data-section-wrapper]',
      container: '[data-ajax-cart-container]',
      template: 'script[data-ajax-cart-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      header: '[data-ajax-cart-header]',
      body: '[data-ajax-cart-body]',
      footer: '[data-ajax-cart-footer]',
      item: '[data-ajax-item][data-id][data-qty]',
      itemRemove: '[data-ajax-cart-item-remove]',
      itemIncrement: '[data-ajax-cart-item-increment]',
      itemDecrement: '[data-ajax-cart-item-decrement]',
      cartBadge: '[data-cart-badge]',
      cartBadgeCount: '[data-cart-badge-count]',
      form: '[data-cart-form]',
      itemQtySelect: '[data-item-quantity-select]',
      updateOgSubscription: '[data-update-subscription]',
      frequencySelector: '[data-subscription-frequency]',
      buyAgain: '.buy-again',
      findifyWidgetId: '[data-widget-id]',
      ogInitialCartDiscount: '[og-initial-cart-discount]',
      ogOffer: 'og-offer',
    };

    var classes = {
      bodyCartOpen: 'ajax-cart-open',
      backdrop: 'ajax-cart-backdrop',
      backdropVisible: 'is-visible',
      cartOpen: 'is-open',
      cartBadgeHasItems: 'has-items',
      cartRequestInProgress: 'request-in-progress'
    };

    /**
     * AjaxCart constructor
     *
     * Adds an `init` method with access to private variables inside the contructor
     */
    function AjaxCart() {
      this.name = 'ajaxCart';
      this.namespace = '.' + this.name;
      this.events = {
        RENDER: 'render' + this.namespace,
        DESTROY: 'destroy' + this.namespace,
        SCROLL: 'scroll' + this.namespace,
        UPDATE: 'update' + this.namespace, //  Use this as a global event to hook into whenever the cart changes
        REFRESH: 'refresh' + this.namespace,
        OPEN: 'open' + this.namespace,
      };

      var initialized = false;
      var settings = {
        disableAjaxCart: false,
        backdrop: true
      };

      this.$el = $(selectors.container);
      this.$backdrop = null;
      this.stateIsOpen = null;
      this.transitionEndEvent = slate.utils.whichTransitionEnd();
      this.requestInProgress = false;

      /**
       * Initialize the cart
       *
       * @param {object} options - see `settings` variable above
       */
      this.init = function(options) {
        if (initialized) return;

        this.settings = $.extend(settings, options);

        if (!$(selectors.template).length) {
          console.warn('[' + this.name + '] - Handlebars template required to initialize');
          return;
        }

        this.$sectionWrapper = $(selectors.sectionWrapper);
        this.$container = $(selectors.container);
        this.$cartBadge = $(selectors.cartBadge);
        this.$cartBadgeCount = $(selectors.cartBadgeCount);

        // The frequency value of the updated subscription
        this.updateFreqRateVal;

        // Compile this once during initialization
        this.template = Handlebars.compile($(selectors.template).html());

        // Add the AJAX part
        if (!this.settings.disableAjaxCart) {
          this._formOverride();
        }

        this.getSellingPlanId.bind(this);

        // Add event handlers here
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        $body.on('click', selectors.itemIncrement, this.onItemIncrementClick.bind(this));
        $body.on('click', selectors.itemDecrement, this.onItemDecrementClick.bind(this));
        $body.on('click', selectors.buyAgain, this.onBuyAgainClick.bind(this));
        $window.on(this.events.RENDER, this.onCartRender.bind(this));
        $window.on(this.events.DESTROY, this.onCartDestroy.bind(this));
        $window.on(this.events.REFRESH, this.refreshCart.bind(this));
        $window.on(this.events.OPEN, this.openCart.bind(this));

        // OG subscription opt in event handlers
        this.$container.on('click', selectors.updateOgSubscription, this.updateSubscription.bind(this));
        this.$container.on('change', selectors.frequencySelector, this.subscriptionFreqChanged.bind(this));

        // OrderGroove renders the offer contents asynchronously, so re-apply the
        // initial discount whenever the offer markup changes
        if (window.MutationObserver && this.$container.length) {
          new MutationObserver(this.updadeInitialDiscount.bind(this))
            .observe(this.$container[0], { childList: true, subtree: true });
        }

        // Get the cart data when we initialize the instance
        ShopifyAPI.getCart().then(this.buildCart.bind(this));

        initialized = true;

        return initialized;
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

      getSellingPlanId: function(e) {
        var variantId = e.target.dataset.updateVariantId;
        var frequency = this.updateFreqRateNumber || e.target.dataset.shippingIntervalFrequency;

        var sellingPlanMapElement = document.querySelector('#og-selling-plan-map-' + variantId + '-' + frequency);
        var sellingPlanId = sellingPlanMapElement ? sellingPlanMapElement.getAttribute("selling-plan-id") : null;
        return sellingPlanId || -1;
      },

      updateSubscription: function(e) {

        var self = this;

        var removeData = {
          line: $(e.target).data('line-num') + 1,
          quantity: 0
        };

        var removeSettings = {
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: removeData
        };
        this._onRequestStart();
        $.ajax(removeSettings).done(function(response) {
          if (response) {
            if ($(e.target).data('purchase-type') === "onetime") {
              var data = {
                quantity: $(e.target).data('item-quantity'),
                id: $(e.target).data('change-variant-id'),
                purchase_type: $(e.target).data('purchase-type')
              };
            } else {
              var subcriptionVarID = $(e.target).data('change-variant-id');
              var subscriptionFrequency;

              if (self.updateFreqRateVal != undefined) {
                subscriptionFrequency = self.updateFreqRateVal;
                subcriptionVarID = $(e.target).data('update-variant-id');
              } else {
                subscriptionFrequency = $(e.target).data('shipping-interval-frequency').split(',')[0]
              }

              var data = {
                quantity: $(e.target).data('item-quantity'),
                id: subcriptionVarID,
                selling_plan: self.getSellingPlanId(e)
              };
            }
            var settings = {
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: data
            };
            $.ajax(settings).done(function(result) {
              if (result) {
                ShopifyAPI.getCart().then(self.buildCart.bind(self));
                self._onRequestFinish();
              }
              console.warn('issue updating cart');
            }).fail(function(xhr) {
              console.warn('error adding new product product type', xhr);
            });
          }
        }).fail(function(xhr) {
          console.warn('error adding removing previous product type', xhr);
        });

      },

      subscriptionFreqChanged: function (e) {
        var self = this;
        var rowNum = $(e.target).data('subscription-frequency');
        var $subscriptionInput = $('[data-update-subscription=' + rowNum + ']');
        var $selectedOption = $(e.target).children("option:selected");
        self.updateFreqRateVal = $selectedOption.data('shipping-interval-frequency');
        self.updateFreqRateNumber = $(e.target).val();
        $subscriptionInput.trigger('click');
      },

      /**
       * Call this function to AJAX-ify any add to cart forms on the page
       */
      _formOverride: function() {
        var _this = this;

        $body.on('submit', selectors.addForm, function(e) {
          e.preventDefault();

          if (this.requestInProgress) return;

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          // check for an active autodeliver input
          var subscriptionInputChecked = $('.rc_block__type__autodeliver.rc_block__type--active');
          if (subscriptionInputChecked.length > 0) {
            $submitButtonText.html(theme.strings.addingSubscription);
          } else {
            $submitButtonText.html(theme.strings.adding);
          }

          this._onRequestStart();

          ShopifyAPI.addItemFromForm($(e.target))
            .then(function(data) {

              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddSuccess.call(_this, data);
            })
            .fail(function(data) {
              _this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddFail.call(_this, data);
            });
        }.bind(this));
      },

      /**
       * Ensure we are working with a valid number
       *
       * @param {int|string} qty
       * @return {int} - Integer quantity.  Defaults to 1
       */
      _validateQty: function(qty) {
        return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
      },

      /**
       * Ensure we are working with a valid number
       *
       * @param {element} el - cart item row or child element
       * @return {obj}
       */
      _getItemRowAttributes: function(el) {
        var $el = $(el);
        var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

        return {
          $row: $row,
          id: $row.data('id'),
          line: ($row.index() + 1),
          qty: this._validateQty($row.data('qty'))
        };
      },

      _onRequestStart: function() {
        this.requestInProgress = true;
        this.$el.addClass(classes.cartRequestInProgress);
      },

      _onRequestFinish: function() {
        this.requestInProgress = false;
        this.$el.removeClass(classes.cartRequestInProgress);
      },

      addBackdrop: function(callback) {

        var _this = this;
        var cb = callback || $.noop;

        if (this.stateIsOpen) {
          this.$backdrop = $(document.createElement('div'));

          this.$backdrop.addClass(classes.backdrop)
            .appendTo($body);

          this.$backdrop.one(this.transitionEndEvent, cb);
          this.$backdrop.one('click', this.close.bind(this));

          // debug this...
          setTimeout(function() {
            _this.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      removeBackdrop: function(callback) {

        var _this = this;
        var cb = callback || $.noop;

        if (!this.stateIsOpen && this.$backdrop) {
          this.$backdrop.one(this.transitionEndEvent, function() {
            _this.$backdrop && _this.$backdrop.remove();
            _this.$backdrop = null;
            cb();
          });

          setTimeout(function() {
            _this.$backdrop.removeClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      /**
       * Callback when adding an item is successful
       *
       * @param {Object} cart - JSON representation of the cart.
       */
      onItemAddSuccess: function(cart) {
        this.buildCart(cart);
        this.open();
      },

      /**
       * STUB - Callback when adding an item fails

       * @param {Object} data
       * @param {string} data.message - error message
       */
      onItemAddFail: function(data) {
        console.warn('[' + this.name + '] - onItemAddFail');
        console.warn('[' + this.name + '] - ' + data.message);
      },

      /**
      * Callback for when the cart HTML is rendered to the page
      * Allows us to add event handlers for events that don't bubble
      */
      onCartRender: function(e) {
        console.log('onCartRender running');
        slate.quantityAdjuster.refresh();

        // Initialize/Update the Findify Recommendation
        this._updateFindifyRec();

        // order groove remove tagged options
        this._customRemoveOptionsFromCart();
      },

      /**
       * Callback for when the cart HTML is removed from the page
       * Allows us to do cleanup on any event handlers applied post-render
       */
      onCartDestroy: function(e) {
      },

      refreshCart: function(e) {
        ShopifyAPI.getCart().then(this.buildCart.bind(this));
      },

      openCart: function(e) {
        this.open();
      },

      /**
       * Builds the HTML for the ajax cart.
       * Modifies the JSON cart for consumption by our handlebars template
       *
       * @param {object} cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
       * @return ??
       */
      buildCart: function(cart) {

        // All AJAX Cart requests finish with rebuilding the cart
        // So this is a good place to add this code
        this._onRequestFinish();

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        // cart.total_price = slate.Currency.stripZeroCents(cart.total_price);

        cart.items.map(function(item) {
          if (item.original_image !== undefined) {
            item.image = slate.Image.getSizedImageUrl(item.original_image, '200x');
          } else {
            item.image = slate.Image.getSizedImageUrl(item.image, '200x');
          }

          const variantId = item.variant_id;
          const variant = item.product.variants.find(variant => variantId == variant.id);

          if (variant.compare_at_price != variant.price) {
            item.comparePrice = slate.Currency.formatMoney(variant.compare_at_price);
          }

          item.originalPrice = slate.Currency.formatMoney(item.original_price);
          item.price = slate.Currency.formatMoney(item.price, theme.moneyFormat);
          // item.price = slate.Currency.stripZeroCents(item.price);

          // Adjust the item's variant options to add "name" and "value" properties
          if (item.hasOwnProperty('product')) {
            var product = item.product;
            for (var i = item.variant_options.length - 1; i >= 0; i--) {
              var name = product.options[i];
              var value = item.variant_options[i];

              item.variant_options[i] = {
                name: name,
                value: value
              };

              // Don't show this info if it's the default variant that Shopify creates
              if (value == "Default Title") {
                delete item.variant_options[i];
              }
            }
          } else {
            delete item.variant_options; // skip it and use the variant title instead
          }

          return item;
        });

        /**
         *  You can also use this as an intermediate step to constructing the AJAX cart DOM
         *  by returning an HTML string and using another function to do the DOM updating
         *
         *  return this.template(cart)
         *
         *  The code below isn't the most elegant way to update the cart but it works...
         */

        $window.trigger(this.events.DESTROY);
        this.$container.empty().append(this.template(cart));
        $window.trigger(this.events.RENDER);
        $window.trigger(this.events.UPDATE);
        slate.utils.chosenSelects();
        this.updateCartCount(cart);
        this.updadeInitialDiscount();
      },

      /**
       * Update the cart badge + count here
       *
       * @param {Object} cart - JSON representation of the cart.
       */
      updateCartCount: function(cart) {

        this.$cartBadgeCount.html(cart.item_count);

        if (cart.item_count) {
          this.$cartBadge.addClass(classes.cartBadgeHasItems);
        }
        else {
          this.$cartBadge.removeClass(classes.cartBadgeHasItems);
        }
      },

      /**
       * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
       *
       * @param {event} e - Click event
       */
      onItemRemoveClick: function(e) {
        e.preventDefault();

        if (this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);

        this._onRequestStart();
        ShopifyAPI.changeLineItemQuantity(attrs.line, 0).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

      /**
       * Increase the quantity of an item by 1
       *
       * @param {event} e - Click event
       */
      onItemIncrementClick: function(e) {
        e.preventDefault();

        if (this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);

        this._onRequestStart();
        ShopifyAPI.changeLineItemQuantity(attrs.line, attrs.qty + 1).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

      /**
       * Decrease the quantity of an item by 1
       *
       * @param {event} e - Click event
       */
      onItemDecrementClick: function(e) {
        e.preventDefault();

        if (this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);
        var newQty = (attrs.qty < 1 ? 0 : attrs.qty - 1);

        this._onRequestStart();
        ShopifyAPI.changeLineItemQuantity(attrs.line, newQty).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

      /**
       * Buy again button click
       *
       * @param {event} e - Click event
       */
      onBuyAgainClick: function(e) {
        e.preventDefault();

        var _this = this;
        if (this.requestInProgress) return;
        this._onRequestStart();
        var $buyButton = $(e.target);
        $buyButton.prop('disabled', true);
        $buyButton.html('Adding...');
        var data = {
          quantity: $buyButton.data('quantity'),
          id: $buyButton.data('variant-id'),
          purchase_type: 'onetime'
        }
        ShopifyAPI.addItem(data).then(function(data) {
          // Reset button state
          $buyButton.prop('disabled', false);
          $buyButton.html('Buy Again');
          _this.onItemAddSuccess.call(_this, data);
        })
          .fail(function(data) {
            _this._onRequestFinish();
            // Reset button state
            $buyButton.prop('disabled', false);
            $buyButton.html('Buy Again');
            _this.onItemAddFail.call(_this, data);
          });
      },

      /**
       * Click the 'ajaxCart - trigger' selector
       *
       * @param {event} e - Click event
       */
      onTriggerClick: function(e) {
        e.preventDefault();
        this.toggleVisibility();
      },

      /**
       * Click the 'ajaxCart - close' selector
       *
       * @param {event} e - Click event
       */
      onCloseClick: function(e) {
        e.preventDefault();

        // Do any cleanup before closing the cart
        this.close();
      },

      /**
       * Opens / closes the cart depending on state
       *
       */
      toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
      },

      /**
       * Check the open / closed state of the cart
       *
       * @return {bool}
       */
      isOpen: function() {
        return this.stateIsOpen;
      },

      /**
       * Returns true is the cart is closed.
       *
       * @return {bool}
       */
      isClosed: function() {
        return !this.stateIsOpen;
      },


      /**
       * Findify - Initialize or update the Findify recommendation widget in the mini-cart
       */
      _updateFindifyRec: function() {
        var _this = this;
        var $widgetRoot = $(selectors.findifyWidgetId, this.$container); // Root element of the recommendation widget
        var widgetId = $widgetRoot.data('widget-id');
        var widgetKey = 'findify-cart-rec'; // Arbitrary key used by Findify SDK to init/fetch a rec via JS

        // If no widget ID, bail
        if (!widgetId) {
          return;
        }

        // Try to fetch the recommendation widget by its key
        var widget = window.findify && findify.widgets && typeof findify.widgets.get == 'function' && findify.widgets.get(widgetKey);

        // If widget exists, detach it (we always have to recreate it bc of the way the Ajax Cart re-renders)
        if (widget && widgetKey && findify && findify.widgets && typeof findify.widgets.detach == 'function') {
          findify.widgets.detach(widgetKey);
        }

        // Fetch cart, then use the cart to
        ShopifyAPI.getCart().then(function(cart) {
          if (Array.isArray(cart.items) && cart.items.length) {
            var productTags = cart.items[0].product.tags;
            var findifyTags = ["Pet Type", "Department", "Features", "Food", "Food Specialty", "Food Flavor", "Age", "Breed Size", "Supplements", "Health Condition", "Flea & Tick", "Holistic Treatment", "Treat Type", "Treat Specialty", "Flavor", "Chew Type", "Grooming", "Litter", "Toys", "Wet Food Texture", "Frozen Raw Style", "Dosage Form", "Skin & Coat Care", "GI Condition", "UT Condition", "Cleaning & Bathroom", "Collars & Leashes", "Beds & Mats", "Bowls", "Clothing & Accessories", "custom_color", "Best Uses", "Packaging Type", "Packaging Sustainability", "Badge"];

            // Get product tags-based filtering data
            var findifyTagsData = _this.getFindifyRules(productTags, findifyTags);

            // Get cart items filtering data
            var productIds = Array.isArray(cart.items) ? cart.items.map(function(li) { return { value: String(li.product_id) } }) : [];
            var variantIds = Array.isArray(cart.items) ? cart.items.map(function(li) { return { value: String(li.variant_id) } }) : [];

            var findifyCartData = [{
              type: "text",
              name: "id",
              values: variantIds // Note: Findify has said to pass both Product IDs and variant IDs on different occasions.  Right now we're only passing variant IDs
            }];

            // Combine rules
            var rulesData = [].concat(findifyTagsData, findifyCartData);

            // Initialize Findify widget
            (window.findifyCallbacks = window.findifyCallbacks || []).push(function(findify) {
              // Set the ID attribute of the widget el to the recommendation widget ID
              // (Note: this is required for Findify to pull in the recommendation title)
              $widgetRoot.attr('id', widgetId);

              // Attach widget
              findify.widgets.attach('#' + widgetId, 'recommendation', {
                slot: widgetId,
                template: 'grid',
                widgetKey: widgetKey,
                ...findify.config.getIn(['features', 'recommendations', widgetId]).toJS()
              });

              findify.widgets.get(widgetKey).agent.defaults({
                rules: rulesData
              });
            });
          }
        });
      },


      /**
       * Retrieve an array of filter values based on the merchant's Findify filter prefixes
       * and the product tags of the cart's current line-items
       *
       * @param {Array} productTags - A list of the product tags for the item(s) to be compared
       * @param {Array} findifyTags - A list of the Findify tag prefixes (specific to the merchant)
       * @returns {Array} - An array of objects in the syntax Findify expects for its `rules` config
       */
      getFindifyRules: function(productTags, findifyTags) {
        var findifyRules = [];
        var self = this;

        findifyTags.forEach(function(findifyTag) {
          var matchingTags = self.getMatchingTags(productTags, findifyTag);

          if (matchingTags.length) {
            findifyRules.push({
              type: 'text',
              name: 'custom_fields.' + findifyTag,
              values: matchingTags
            })
          }
        })

        return findifyRules;
      },

      /**
       * For Order Groove Producs in the Cart, the admin wants the ability to hide specific frequency rates on specific products.
       * To do this the product is tagged with the rates that should be hidden. This code follows the same logic as the one on the PDP to remove those frequency rates.
       * @returns
       */
      _customRemoveOptionsFromCart: function() {
        let minicartItems = document.querySelectorAll(
          '.ajax-cart__body li.ajax-cart__item'
        );
        console.log('customRemoveOptionsFromCart running');
        if (!minicartItems) {
          return;
        }
        console.log('customRemoveOptionsFromCart has minicartitems');
        [...minicartItems].forEach(function(cartItem) {
          const ogOffer = cartItem.querySelector('og-offer');
          if (ogOffer) {
            const tags = ogOffer.getAttribute('data-tags').split(',');
            const returningSubscriber = ogOffer.getAttribute('data-returning-subscriber') === 'true';
            if(returningSubscriber){
              $(ogOffer).find('#rc_label__autodeliver-message-1,#rc_label__autodeliver-message-1 + br ').hide();
              $(ogOffer).find('#rc_label__autodeliver-message-3').show();
            }
            const product = { tags: tags };
            return setTimeout(() => {
              slate.ordergrooveEnrollment.handleFrequencySelector(
                $(ogOffer),
                product
              );
              slate.ordergrooveEnrollment.removeIncentiveText(
                product.tags,
                ogOffer
              );
            }, 200);
          }
          return ogOffer;
        });
      },

      /**
       * Compare an array of product tag strings to a specific Findify filter prefix to find matches.
       * @param {Array} productTags - An array of product tags to compare
       * @param {String} findifyTag - a single Findify filter tag prefix
       * @returns {Array} - An array of filter values that matched the prefix
       */
      getMatchingTags: function(productTags, findifyTag) {
        var filteredTags = [];

        productTags.forEach(function(productTag) {
          var tagName = productTag.split(':');

          if (tagName[0] == findifyTag) {
            filteredTags.push({ "value": tagName[1] });
          }
        });

        return filteredTags;
      },

      /**
       * STUB METHOD - Code for opening the cart
       */
      open: function() {
        if (this.stateIsOpen) return;
        this.stateIsOpen = true;

        if (this.settings.backdrop) {
          $body.addClass(classes.bodyCartOpen);
          this.addBackdrop();
        }

        this.$el.addClass(classes.cartOpen);
      },

      /**
       * STUB METHOD - Code for closing the cart
       */
      close: function() {
        if (!this.stateIsOpen) return;

        this.stateIsOpen = false;

        this.$el.removeClass(classes.cartOpen);

        if (this.settings.backdrop) {
          this.removeBackdrop(function() {
            $body.removeClass(classes.bodyCartOpen);
          });
        }

      },

      /**
       * Update OrderGroove initial discount
       */
      updadeInitialDiscount: function() {
        var defaultPercent = window.cartPricing.initialDiscountPercentage;

        $(selectors.ogOffer, this.$container).each(function() {
          var $offer = $(this);
          var discountPercent = $offer.data('initial-discount') || defaultPercent;
          var discountText = `${discountPercent}%`;

          $(selectors.ogInitialCartDiscount, $offer).each(function() {
            // Only write when changed to avoid retriggering the MutationObserver
            if (this.textContent !== discountText) {
              this.textContent = discountText;
            }
          });
        });
      }
    });

    return AjaxCart;
  })();

})(jQuery, Handlebars, slate);


/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend($.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInQuint: function(x, t, b, c, d) {
      return c * (t /= d) * t * t * t * t + b;
    },
    easeOutQuint: function(x, t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    easeInOutQuint: function(x, t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
  });

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base: 300,
    fast: 150,
    fastest: 50,
    slow: 600,
    medium: 400,
    none: 0
  };

  var _transitionTimingFunctions = {
    base: 'ease-in-out',
    in: 'ease-out',
    out: 'ease-in',
    inOutUI: 'cubic-bezier(0.42, 0, 0.13, 1.04)'
  };

  /**
   * Get one of the durations stored in the variable defined above
   * If the requested duration doesn't exist, fallback to the base
   *
   * @param {string} key - string matching one of the key names
   * @return {int} - duration in ms
   */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if (_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  }

  /**
   * Get one of the timing functions stored in the variable defined above
   * If the requested function doesn't exist, fallback to the base
   *
   * @param {string} key - string matching one of the key names
   * @return {string} - valid css timing function
   */
  function getTransitionTimingFunction(key) {
    var k = 'base';
    if (_transitionTimingFunctions.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingFunctions[k];
  }

  return {
    getTransitionTimingDuration: getTransitionTimingDuration,
    getTransitionTimingFunction: getTransitionTimingFunction
  };

}(jQuery));

/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 *
 * @namespace user
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_ztheme_';

  /**
   * User constructor
   */
  function User() {
    this.name = 'user';
    this.namespace = '.' + this.name;
    return this;
  }

  User.prototype = $.extend({}, User.prototype, {

    /**
     * Library of cookies to use throughout the site.
     * Use the `generateCookie` method below to create your own copies of these.  Don't access these directly.
     */
    _cookies: {
      siteVisit: {
        name: cookiePrefix + 'site_visit',
        value: true
      },
      subscriptionSlideupSeen: {
        name: 'subscriptionSlideup_seen',
        value: true
      },
      subscriptionModalSeen: {
        name: 'subscriptionModal_seen',
        value: true
      },
      emailCollected: {
        name: 'emailCollected',
        value: true
      },
      adblockModalSeen: {
        name: 'adblockModalSeen',
        value: true
      }
    },

    /**
     * Creates and returns a copy of one of the cookies available above
     *
     * @param {String} key
     * @return {Object | undefined}
     */
    generateCookie: function(key) {
      var c;
      if (this._cookies.hasOwnProperty(key)) {
        c = $.extend(true, {}, this._cookies[key]);
        c.name = cookiePrefix + c.name;
      }
      else {
        console.warn('[' + this.name + '] - Cannot create cookie.  Key "' + key + '" not found.');
      }
      return c;
    },

    /**
     * Sets a browser cookie
     *
     * @param {Object} cookie
     * @param {String} cookie.name
     * @param {String} cookie.value
     * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
     */
    setCookie: function(cookie) {
      if (this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value) {
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires: cookie.expiration } : {};
      Cookies.set(cookie.name, cookie.value, opts);

      return this;
    },

    /**
     * Checks for the presence of a browser cookie by name (doesn't check for value equality)
     *
     * @param {String} cookieName
     * @return {Boolean}
     */
    hasCookie: function(cookieName) {
      return typeof Cookies.get(cookieName) !== "undefined";
    },

    /**
     * Returns value of browser cookie by name
     *
     * @param {String} cookieName
     * @return {String | Undefined}
     */
    getCookieValue: function(cookieName) {
      return this.hasCookie(cookieName) ? Cookies.get(cookieName.name) : undefined;
    },

    /**
     * Removes a cookie by name
     *
     * @param {String} cookieName
     * @return {Self}
     */
    removeCookie: function(cookieName) {
      Cookies.remove(cookieName);
      return this;
    },
  });

  return new User();

}(Cookies));

/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width();

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 1092,
    lg: 1300,
    xl: 1440
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };


  /**
   * Get one of the widths stored in the variable defined above
   *
   * @param {string} key - string matching one of the key names
   * @return {int} - pixel width
   */
  function getBreakpointMinWidth(key) {
    if (!key) return;

    if (_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

  /**
   * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
   * So if we pass in a width between 'sm' and 'md', this will return 'sm'
   *
   * @param {int} w - width
   * @return {undefined|string} foundKey
   */
  function getBreakpointMinWidthKeyForWidth(w) {
    w = w != undefined ? w : $window.width();

    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if (w >= bpMinWidth) {
        foundKey = k;
      }
    });

    return foundKey;
  }

  /**
   * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
   *
   */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if ((newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth)) {

        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
  }

  $window.on('resize', $.throttle(20, onResize));

  return {
    getBreakpointMinWidth: getBreakpointMinWidth,
    getBreakpointMinWidthKeyForWidth: getBreakpointMinWidthKeyForWidth
  };

}(jQuery));

/**
 * Product Card Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the product card html (see snippets/product-card.liquid)
 */

slate.productCard = (function() {

  var selectors = {
    el: '[data-product-card]',
    mainLazyImg: '[data-product-card-main-lazy]',
    singleOptionSelector: '[data-single-option-selector]',
    originalSelectorId: '[data-product-select]',
    productJson: '[data-product-json]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    infoPrice: '[data-info-price]'
  };

  function onVariantChange(e) {
    updateAddToCart(e.variant, this);
  }

  function updateAddToCart(variant, el) {
    if (variant.available == true) {
      var addToCartMsg = $(selectors.addToCart, el).data('available-text');
      var productJson = getProductJsonParse(el);

      var image = productJson && productJson.featured_image;

      if (variant.featured_image.src) {
        image = variant.featured_image.src;
      }

      $(selectors.addToCart, el).prop('disabled', false);
      $(selectors.addToCartText, el).text(addToCartMsg);
      $(selectors.infoPrice, el).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
      $(selectors.mainLazyImg, el).attr('src', image);
    } else {
      var unavailableMsg = $(selectors.addToCart, el).data('sold-out-text');

      $(selectors.addToCart, el).prop('disabled', true)
      $(selectors.addToCartText, el).text(unavailableMsg);
    }
  }

  function getProductJsonParse(el) {
    try {
      json = JSON.parse($(selectors.productJson, el).html());
      return json;
    } catch (e) {
      console.warn("Error parsing JSON");
      return false;
    }
  }

  $(document).ready(function() {

    var $productCards = $(selectors.el);

    if (!$productCards.length) {
      return;
    }

    $productCards.each(function(index, el) {
      var $el = $(el);

      if ($el.hasClass('product-card--quick-buy')) {
        var variantsOptions = {
          $container: $el,
          enableHistoryState: false,
          singleOptionSelector: selectors.singleOptionSelector,
          originalSelectorId: selectors.originalSelectorId,
          product: getProductJsonParse(el)
        };
        new slate.Variants(variantsOptions);

        if (!$el.find(selectors.originalSelectorId)[0].value) {
          $(selectors.addToCart, el).prop('disabled', true);
        }

        $el.on('variantChange', onVariantChange.bind(el));
      }
    });
  });
}());

/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant galleries + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency)
 */

// Requires slate for slate.Currency

slate.ProductDetailForm = (function($, Modernizr, slate) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    backInStockFormSubmit: '[data-back-in-stock-form-submit]',
    backInStockToggler: '[data-back-in-stock-toggler]',
    addToCartPrice: '[data-add-to-cart-price]',
    rivoRewards: '.product-detail-rivo-loy-message',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productZoomButton: '[data-zoom-button]',
    productGallery: '[data-product-gallery]',
    productGallerySlideshow: '[data-product-gallery-slideshow]',
    productGallerySlideLink: '[data-product-gallery-slide-link]',
    productGalleryThumbnails: '[data-product-gallery-thumbnails]',
    productGalleryThumbnailsSlide: '[data-product-gallery-thumbnails-slide]',
    initialSlide: '[data-initial-slide]',
    productJson: '[data-product-json]',
    productMsrp: '[data-product-msrp]',
    productPrice: '[data-product-price]',
    comparePrice: '[data-compare-price]',
    productPriceWrapper: '[data-product-price-wrapper]',
    promoWrapper: '.add-to-cart-promo-wrapper',
    comparePriceText: '[data-compare-text]',
    firstADPrice: '[data-first-ad-product-price]',
    firstADComparePrice: '[data-first-ad-compare-price]',
    recurringADPrice: '[data-recurring-ad-product-price]',
    recurringADComparePrice: '[data-recurring-ad-compare-price]',
    singleOptionSelector: '[data-single-option-selector]',
    variantOptionValueList: '[data-variant-option-value-list][data-option-position]',
    variantOptionValue: '[data-variant-option-value]',
    quantitySelect: '[data-product-quantity-select]',
    currentVariantQuantity: '[data-current-variant-quantity]',
    scrollTo: '[data-scroll-to]',
    fadeOnScroll: '[data-fade-on-scroll]',
    productTitleVariant: '[data-product-title-variant]',
    variantNoteContainer: '[data-variant-note-container]',
    productNote: '[data-product-note]',
    variantNote: '[data-variant-note]',
    containerID: 'data-section-id',
    productSubscriptionToggled: '[data-radio-subscription-toggle]',
    bisVariantName: '[data-variant-title]',
    bisVariantSKU: '[data-bis-variant-sku]',
    bisAlertId: '[data-bis-alert-id]',
    bisUserEmail: '[data-bis-user-email]',
    bisModal: '[data-back-in-stop-modal]',
    productCardEyebrow: '.product-card__eyebrow',
    subscriptionWidget: '#rc_container',
    subscriptionRadioInput: '[id^="rc_purchase_type"]',
    subscriptionPrice: '.rc_price',
    subscriptionInputs: '#rc_container input',
    //wishlistButton: '.gift-reggie-wishlist-button',
    currentSKU: '[data-product-sku-variant]',
    shippingList: '#ShippingList',
    selectedShippingState: '[data-selected-state]',
    shippingUnavailableMessage: '[data-shipping-unavailable-text]',
    rcSubscriptionInput: '[data-rc-input]',
    rcComparePrice: '[data-rc-compare-price]',
    quantityAvailableWrapper: '[data-quantity-available-wrapper]',
    quantityAvailable: '[data-quantity-available]',
    servingPrice: '[data-serving-price]',
    quantitySelectorWrapper: '[data-quantity-selector-wrapper]',
    ogSubscribedSelector: '.product-options-form og-offer og-optin-button[subscribed]',
    ogOfferWidget: '#add-item-form og-offer',
    ogOfferIncentives: '.offer-incentives',
    ogSubscriptionPriceWrapper: '.price-wrapper--subscription',
    ogComparePrice: '[data-og-compare-price]',
    ogOnetimePriceWrapper: '[og-onetime-price-wrapper]',
    ogInitialDiscount: '[og-initial-discount]',
    ogInitialDiscountPercentage: '[og-initial-discount-percentage]',
    ogInitialDiscountCallout: '[og-initial-discount-callout]',
    ogRecurringDiscountPercentage: '[og-recurring-discount-percentage]',
    $ogMaxSavingsContainer: '[og-max-savings]',
    $ogMaxSavings: '[data-max-savings]',
  };

  var classes = {
    hide: 'hide',
    visualHide: 'visually-hidden',
    variantOptionValueActive: 'is-active',
    zoomReady: 'is-zoomable',
    zoomedIn: 'is-zoomed',
    isActive: 'is-active',
    disabled: 'is-disabled',
    success: 'success',
    isOnSale: 'is-on-sale',
    addToCartButtonSubscribed: 'subscribe',
  };

  var $window = $(window);

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   * @param { Boolean } config.enableHistoryState - If set to "true", turns on URL updating when switching variants
   * @param { Function } config.onReady -  Called after the product form is initialized.
   */
  function ProductDetailForm(config) {

    this.settings = {};
    this.name = 'productDetailForm';
    this.namespace = '.' + this.name;

    this.events = {
      RESIZE: 'resize' + this.namespace,
      CLICK: 'click' + this.namespace,
      READY: 'ready' + this.namespace,
      CHANGE: 'change'
    };

    var ready = false;
    var options = options || {};
    var defaults = {
      enableHistoryState: true,
      enableZoom: true
    };

    this.initialize = function() {
      if (ready) {
        return;
      }

      this.settings = $.extend({}, defaults, config);

      if (!this.settings.$el || this.settings.$el == undefined) {
        console.warn('[' + this.name + '] - $el required to initialize');
        return;
      }

      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

      slate.utils.chosenSelects(this.$container);

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        variantOptionValueList: selectors.variantOptionValueList,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(variantOptions);

      // See slate.Variants
      this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));

      // Detect presence of subscription toggle.
      this.$subscriptionToggle = $(selectors.subscriptionRadioInput, this.$container);
      this.$subscriptionToggle.on('change', this.onSubscriptionToggleChange.bind(this));
      window.OG.addOptinChangedCallback(this.onSubscriptionToggleChange.bind(this));
      document.addEventListener("DOMContentLoaded", this.handleOfferIncentivesVisibility.bind(this));

      // Initialization functions
      this.initGalleries();
      this.initForm();

      //Show "Compare price" when product is not on sale but is AD
      this.$rcSubscriptionInput = $(selectors.rcSubscriptionInput, this.$container);
      this.$rcComparePrice = $(selectors.rcComparePrice, this.$container);

      $(selectors.backInStockFormSubmit, this.$container).on('click', this.backInStockSubmit.bind(this));
      this.$container.on(this.events.CLICK, selectors.variantOptionValue, this.onVariantOptionValueClick.bind(this));
      this.$container.on(this.events.CLICK, selectors.scrollTo, this.scrollToNextSection.bind(this));
      this.$container.on(this.events.CLICK, selectors.backInStockToggler, this.restartModalStatus.bind(this));

      var e = $.Event(this.events.READY);
      this.$el.trigger(e);

      var $quantitySelect = $(selectors.quantitySelect, this.$container);
      $quantitySelect.on('change', this.updatePriceFromQuantity.bind(this));

      this.handleInitialDiscountElems();

      ready = true;

      // Add CSS styles to Ordergroove enrollment widget
      // slate.ordergrooveEnrollment.removeIncentiveText(this.productSingleObject.tags, document.querySelector(selectors.ogOfferWidget));

      setTimeout(() => {
        slate.ordergrooveEnrollment.handleFrequencySelector(this.$container, this.productSingleObject);
      }, 500);

      // slate.ordergrooveEnrollment.preSelectSubscription(this.$container, this.productSingleObject.selected_or_first_available_variant.id, this.productSingleObject);
    };

    return this;
  }

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {
    // Back in stock modal updates so it submits the right information.

    restartModalStatus: function() {
      $(selectors.bisModal, this.$container).removeClass(classes.success);
    },

    updateBISModal: function(variant) {
      var $variantName = $(selectors.bisVariantName);
      var $variantSKU = $(selectors.bisVariantSKU);
      $variantName.text(variant.title);
      $variantSKU.val(variant.sku);
    },

    updateProductSKU: function(variant) {
      var $currentSKUcontainer = $(selectors.currentSKU, this.$container);
      var $currentSKU = variant.sku;

      $currentSKUcontainer.text('SKU : ' + '' + $currentSKU);
    },

    backInStockSubmit: function(e) {
      e.preventDefault();

      var userEmail = $(selectors.bisUserEmail, selectors.backInStockForm).val();
      var productSKU = $(selectors.bisVariantSKU, selectors.backInStockForm).val();
      var alertId = $(selectors.bisAlertId, selectors.backInStockForm).val();

      if (window._ltk && window._ltk.Alerts) {
        window._ltk.Alerts.AddAlert(userEmail, productSKU, alertId);
        window._ltk.Alerts.Submit();
      }

      $(selectors.bisModal, this.$container).addClass(classes.success);
    },

    initForm: function() {
      var variant;
      // if there is no selected variant check the url for an id and if nothing, set it to the first variant
      // ?? Why aren't we using this.variants.currentVariant?
      var variantIdURL = this.getVariantID();
      var subscriptionType = this.getSubscriptionType();
      if (variantIdURL != undefined) {
        for (var i = 0; i < this.productSingleObject.variants.length; i++) {
          if (this.productSingleObject.variants[i].id == variantIdURL) {
            variant = this.productSingleObject.variants[i];
          }
        }
      } else {
        variant = this.productSingleObject.variants[0];
      }
      this.fadeOnScroll();
      if (subscriptionType.type == "subscription") {
        setTimeout(function() {
          $($('.rc_block__type input')[1]).click();
          $('.rc_block select').find('option[value=' + subscriptionType.frequency + ']').prop('selected', true);
          $('.rc_block select').trigger('change');
        }, 2500);
      }
      // Call on variant change manually on init to set initial label/title values
      this.onVariantChange({ variant: this.variants.currentVariant });
    },

    initGalleries: function() {
      var self = this;
      var $galleries = $(selectors.productGallery, this.$container);

      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function initHoverZoom($zoomTarget) {
        if ($zoomTarget.find(selectors.productGallerySlideLink).length < 1) {
          return;
        }
        var opts = {
          url: $zoomTarget.find(selectors.productGallerySlideLink).attr('href'),
          on: 'mouseover',
          touch: false,
          escToClose: true,
          magnify: 1.8,
          duration: 300,
          callback: function() {
            $zoomTarget.addClass(classes.zoomReady);
          },
          onZoomIn: function() {
            $zoomTarget.addClass(classes.zoomedIn);
          },
          onZoomOut: function() {
            $zoomTarget.removeClass(classes.zoomedIn);
          }
        };

        $zoomTarget.zoom(opts);

        $zoomTarget.find(selectors.productZoomButton).on('click', function(e) {
          $zoomTarget.trigger('click');
          return false;
        });
      }

      function destroyHoverZoom($zoomTarget) {
        $zoomTarget.trigger('zoom.destroy');
        $zoomTarget.find(selectors.productZoomButton).off('click');
      }

      function onSlideshowSlickBeforeChange(e, slick) {
        var $zoomTarget = $(slick.$slides[slick.currentSlide]);
        if (self.settings.enableZoom) {
          destroyHoverZoom($zoomTarget);
        }
      }

      function onSlideshowSlickAfterChange(e, slick) {
        var $zoomTarget = $(slick.$slides[slick.currentSlide]);
        if (self.settings.enableZoom) {
          initHoverZoom($zoomTarget);
        }
      }

      $galleries.each(function() {
        var $slideshow = $(this).find(selectors.productGallerySlideshow);
        var $thumbnails = $(this).find(selectors.productGalleryThumbnails);

        // Look for element with the initialSlide selector.
        var initialSlide = $(this).find(selectors.initialSlide).length ? $(this).find(selectors.initialSlide).index() : 0;

        var thumbnailsSlidesCount = $thumbnails.children().length;

        $slideshow.on({
          beforeChange: onSlideshowSlickBeforeChange,
          afterChange: onSlideshowSlickAfterChange
        });

        $slideshow.slick({
          speed: 600,
          dots: false,
          swipe: Modernizr.touchevents,
          arrows: !Modernizr.touchevents,
          adaptiveHeight: false,
          asNavFor: '#' + $thumbnails.attr('id'),
          prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
          nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',
          initialSlide: initialSlide,
          accessibility: false,
          draggable: true,
          lazyLoad: 'ondemand',
          responsive: [
            {
              breakpoint: 1091,
              settings: {
                dots: true
              }
            }
          ]
        });

        $thumbnails.on('click', selectors.productGalleryThumbnailsSlide, function() {
          $slideshow.slick('slickGoTo', $(this).data('slick-index'));
        });

        $thumbnails.slick({
          speed: 600,
          slidesToShow: 5,
          slidestoScroll: 1,
          infinite: false,
          arrows: true,
          prevArrow: '<div style="display: none;"></div>',
          nextArrow: $('.thumbnail-carousel-down'),
          vertical: false,
          asNavFor: '#' + $slideshow.attr('id'),
          initialSlide: initialSlide,
          accessibility: false,
          centerMode: false,
          focusOnSelect: false,
          lazyLoad: 'progressive'
        });

        if (thumbnailsSlidesCount < 6) {
          $thumbnails.addClass('no-scroll');
        }
      });

      // Because slick can get weird on initialization, make sure we call `refresh` on any visible galleries
      $galleries.not('.hide').each(function() {
        var $variantGallery = $(this);
        $variantGallery.find(selectors.productGallerySlideshow)?.slick('getSlick').refresh();
        $variantGallery.find(selectors.productGalleryThumbnails)?.slick('getSlick').refresh();
      });
    },

    /**
     * Scrolling Helper Functions
     *
     */
    scrollToNextSection: function(e) {
      e.preventDefault();
      var $this = $(e.target);
      var formEnd = $this.offset().top + $this.outerHeight() - 100;

      $('html, body').animate({
        scrollTop: (formEnd),
      }, {
        duration: 1000
      })
    },

    fadeOnScroll: function() {
      var $fadeOnScroll = $(selectors.fadeOnScroll, this.$container);
      if ($fadeOnScroll != undefined) {
        $window.on('scroll', function() {
          var scrollTop = $window.scrollTop();
          var height = $window.height();

          $(selectors.fadeOnScroll).css({
            'opacity': ((height - scrollTop) / height)
          });
        });
      }
    },

    /**
     * Form State Helpers
     * used to get variant id from url and set initial form state on page load if it exists
     */
    getVariantID: function () {
      var params = new URLSearchParams(window.location.search);
      return params.get('variant') || undefined;
    },
    /**
     * Form State Helpers
     * used to get variant id from url and set initial form state on page load if it exists
     */
    getSubscriptionType: function () {
      var params = new URLSearchParams(window.location.search);
      var type = params.get('type') || '';
      var frequency = params.get('frequency') || 0;
      return {
        type: type,
        frequency: frequency
      };
    },
    /**
     * Slick sliders are annoying and sometimes need an ass kicking
     *
     */
    resizeGalleries: function() {
      $('.slick-slider', this.$container).resize();
    },

    checkIsOptedIn: function() {
      let isOptedIn = false;
      if(document.querySelector('og-optin-button')){
        if (document.querySelector('og-optin-button').shadowRoot.querySelector('button.active')){
          isOptedIn = true;
        }
      }
      return isOptedIn;
    },

    onVariantChange: function(evt) {
      var self = this;
      var variant = evt.variant;

      this.hideOgInitialDiscountElem();

      this.updateAvailableQuantity(variant);

      this.handleOfferIncentivesVisibility();

      this.updateOgWidget(variant);

      this.updateInitialDiscountCallout();

      setTimeout(function() {
        var canbeAutoDelivered = self.checkAutoshipEligible(variant.id);
        var isOptedIn = self.checkIsOptedIn();
        self.updateAddToCartState(variant);
        self.updateQuantityDropdown(variant);
        self.updateVariantOptionValues(variant);
        self.updateGalleries(variant);
        self.updateBadges(variant);
        self.updateVariantNote(variant);
        self.updateAddToCartBtnPrice(variant, canbeAutoDelivered && isOptedIn, slate.Currency.formatMoney(self.getFirstADPrice(variant.id), theme.moneyFormat));
        self.updateDiscountPercentages(variant);
        self.updatePromotions(variant);
        self.updateProductPrices(variant, isOptedIn);
        self.handleInitialDiscountElems(variant);
      }, 400);

      if (typeof variant !== "undefined" && window._ltk && window._ltk.Activity && this.domReady == true) {
        _ltk.Activity.AddProductBrowse(variant.sku);
      } else {
        var checkExist = setInterval(function() {
          if (window._ltk && window._ltk.Activity && typeof window._ltk.Activity.AddProductBrowse == 'function') {
            setTimeout(function() {
              window._ltk.Activity.AddProductBrowse(variant.sku);
              clearInterval(checkExist);
            }, 2000);
          }
        }, 3000);
      }

      this.updateProductSKU(variant);

      $(selectors.singleOptionSelector, this.$container).trigger('chosen:updated');

      this.domReady = true;
    },

    updatePriceFromQuantity: function() {
      const variant = this.variants.currentVariant;
      const subscriptionPrice = this.getFirstADPrice(variant.id);
      const subscriptionPriceFormatted = slate.Currency.formatMoney(subscriptionPrice, theme.moneyFormat);
      const isOptedIn = this.checkIsOptedIn();

      // update price
      this.updateAddToCartBtnPrice(variant, isOptedIn, subscriptionPriceFormatted);
    },

    /**
     * Updates the price on the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */

    updateAddToCartBtnPrice: function(variant, isRecurring, subscriptionPriceFormatted) {
      var $addToCartPrice = $(selectors.addToCartPrice, this.$container);
      // $addToCartPrice.removeClass(classes.hide);
      var $productPriceWrapper = $(selectors.productPriceWrapper, this.$container);

      $productPriceWrapper.removeClass(classes.hide);

      if (isRecurring && subscriptionPriceFormatted) {
        $addToCartPrice.html(subscriptionPriceFormatted).show();
      } else {
        $addToCartPrice.html(variant.price_money);
      }

      let isSubscribed = $(selectors.ogSubscribedSelector).length;
      if (isSubscribed) {
        $productPriceWrapper.removeClass(classes.hide);
        if (window.orderGrooveAutoDelivery?.hideAuto) {
          $productPriceWrapper.addClass(classes.hide);
        }
      }

      // Update the Rivo Rewards Message
      this.updateRivoRewardsMessage(variant, isRecurring, subscriptionPriceFormatted);
    },

    updateRivoRewardsMessage: function(variant, isRecurring, subscriptionPriceFormatted) {
      const rivoContainer = $(selectors.rivoRewards, this.$container);
      const rivoPrice =
        isRecurring && subscriptionPriceFormatted
          ? parseFloat(subscriptionPriceFormatted.replace(/[^0-9.]/g, ''))
          : variant.price / 100;

      const rivoRewardsMessage = rivoContainer.data('rivo-message');
      const rivoBalanceToCashMultiplier = rivoContainer.data('rivo-balance-to-cash-multiplier');
      const rivoCashBackMoney = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(rivoPrice * rivoBalanceToCashMultiplier);

      const updatedRivoMessage = rivoRewardsMessage.replace('[[cash]]', rivoCashBackMoney);
      rivoContainer.html(updatedRivoMessage);
    },

    updatePromotions: function(variant) {
      if (!variant.id) return;
      const promo_wrapper = $(selectors.promoWrapper, this.$container);
      const variant_promotions = promo_wrapper.find('[data-variant-id]');
      variant_promotions.each(function(index, element) {
        $(element).toggleClass('active', $(element).data('variant-id') === variant.id);
      });
    },

    updateDiscountPercentages: function(variant) {
      if (!variant.id) {
        return;
      }

      var $initialDiscountPercentage = $(selectors.ogInitialDiscountPercentage, this.$container);
      var $recurringDiscountPercentage = $(selectors.ogRecurringDiscountPercentage, this.$container);

      const isReturningSubscriber = this.isReturningSubscriber();
      let firstDiscount = this.getFirstDiscountPercentage(variant.id);
      let recurringDiscount = this.getRecurringDiscountPercentage(variant.id);

      if (isReturningSubscriber) {
        firstDiscount = recurringDiscount;
      }
      if (firstDiscount) {
        $initialDiscountPercentage.text(`${firstDiscount}%`);
      }


      if (recurringDiscount) {
        $recurringDiscountPercentage.text(`${recurringDiscount}%`);
      }
    },

    updateInitialDiscountCallout: function() {
      var $initialDiscountCallout = $(selectors.ogInitialDiscountCallout, this.$container);
      if (window.orderGrooveAutoDelivery?.hideAuto || this.isReturningSubscriber()) {
        if (window.orderGrooveAutoDelivery.message2) {
          $initialDiscountCallout.find('div').text(
            window.orderGrooveAutoDelivery.message2
          );
        } else {
          $initialDiscountCallout.hide();
        }
      }
    },

    updateAddToCartState: function(variant) {
      var $addToCartBtn = $(selectors.addToCart, this.$container);
      var $addToCartBtnText = $(selectors.addToCartText, this.$container);
      var $addToCartBtnText = $(selectors.addToCartText, this.$container);
      var $addToCartBtnPrice = $(selectors.addToCartPrice, this.$container);
      var $priceWrapper = $(selectors.priceWrapper, this.$container);
      var $currentVariantQuantity = $(selectors.currentVariantQuantity, this.$container);
      var $backInStockToggler = $(selectors.backInStockToggler, this.$container);
      var $shippingListSelect = $(selectors.shippingList, this.$container);
      var $selectedShippingState = $(selectors.selectedShippingState, this.$container);
      var $shippingUnavailableMessage = $(selectors.shippingUnavailableMessage, this.$container);

      if (variant) {
        $priceWrapper.removeClass(classes.hide);
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.unavailable);
        $priceWrapper.addClass(classes.hide);
        return;
      }

      // will eventually be replaced by back in stock
      if (variant.inventory_quantity < 6) {
        var leftInStockText = "Only " + variant.inventory_quantity + " left in stock";
        if (variant.inventory_quantity === 0) {
          leftInStockText = variant.inventory_quantity + " left in stock";
        }
        $currentVariantQuantity.text(leftInStockText);
        $currentVariantQuantity.removeClass(classes.hide);
      } else {
        $currentVariantQuantity.addClass(classes.hide);
      }

      if (variant.available) {
        $addToCartBtn.show();
        $addToCartBtnText.html(theme.strings.addToCart);
        $backInStockToggler.hide();
      } else {
        $addToCartBtnText.html(theme.strings.soldOut);
        if (variant.sku.length != 0) {
          $addToCartBtn.hide();
          $backInStockToggler.show();
          this.updateBISModal(variant);
        }
      }

      if ($shippingListSelect.length) {
        addToCartButtonDisabled();

        $shippingListSelect.chosen().change(function() {
          var selectedStateValue = $(this).chosen().val();
          var selectedState = $(this).chosen().find("option:selected").text();
          $selectedShippingState.text(selectedState);
          addToCartButtonDisabled();

          if (selectedStateValue != 'empty') {
            addToCartButtonEnabled();
          }
        });

        function addToCartButtonDisabled() {
          $addToCartBtn.prop('disabled', true);
          $addToCartBtn.css({
            "background-color": "#9B9B9B",
            "opacity": "1",
            "color": "#FFFFFF",
            "border-color": "#9B9B9B",
          });
          $addToCartBtnPrice.css("display", "none");
          $addToCartBtnText.css("display", "none");
          $shippingUnavailableMessage.css("display", "inline-block");
        }

        function addToCartButtonEnabled() {
          $addToCartBtn.prop('disabled', false);
          $addToCartBtn.css({
            "background-color": "",
            "opacity": "",
            "color": "",
            "border-color": "",
          });
          $shippingUnavailableMessage.css("display", "none");
          $addToCartBtnPrice.css("display", "inline-block");
          $addToCartBtnText.css("display", "inline-block");
        }
      }
    },

    updateVariantNote: function(variant) {
      var $variantNoteContainer = $(selectors.variantNoteContainer, this.$container);
      var $productNote = $(selectors.productNote, this.$container);
      var $variantNote = $(selectors.variantNote, this.$container);
      if (!variant) {
        $variantNoteContainer.hide();
      } else if (variant.metafields.note != null) {
        $variantNote.text(variant.metafields.note);
        $variantNoteContainer.show();
        $variantNote.show();
        $productNote.hide();
      } else if ($productNote.length != 0) {
        $variantNote.hide();
        $productNote.show();
      } else {
        $variantNoteContainer.hide();
      }
    },

    /**
     * Updates the disabled property of the quantity select based on the availability of the selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateQuantityDropdown: function(variant) {
      var $select = $(selectors.quantitySelect, this.$container);

      // Close the dropdown while we make changes to it
      $select.trigger('chosen:close');

      if (variant && variant.available) {
        $select.prop('disabled', false);
      }
      else {
        $select.prop('disabled', true);
      }

      $select.trigger('chosen:updated');
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     * @param {Bool} isOptedIn - isOptedIn Ordergroove Variable
     */
    updateProductPrices: function (variant, isOptedIn) {
      var $productMsrp = $(selectors.productMsrp, this.$container);
      var $productPrice = $(selectors.productPrice, this.$container);
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add($(selectors.comparePriceText, this.$container));
      var $rcComparePrice = $(selectors.rcComparePrice, this.$container);
      var $ogComparePrice = $(selectors.ogComparePrice, this.$container);
      var $ogOnetimePriceWrapper = $(selectors.ogOnetimePriceWrapper, this.$container);
      var $ogInitialDiscount = $(selectors.ogInitialDiscount, this.$container);
      var $ogSubscriptionPriceWrapper = $(selectors.ogSubscriptionPriceWrapper, this.$container);
      var $ogMaxSavingsContainer = $(selectors.$ogMaxSavingsContainer, this.$container);
      var $ogMaxSavings = $(selectors.$ogMaxSavings, this.$container);
      var $firstADPrice = $(selectors.firstADPrice, this.$container);
      var $firstADComparePrice = $(selectors.firstADComparePrice, this.$container);
      var $recurringADPrice = $(selectors.recurringADPrice, this.$container);
      var $recurringADComparePrice = $(selectors.recurringADComparePrice, this.$container);
      var $atcPrice = $(selectors.addToCartPrice, this.$container);
      var canbeAutoDelivered = this.checkAutoshipEligible(variant.id);
      var firstADPrice = this.getFirstADPrice(variant.id);
      var recurringADPrice= this.getRecurringADPrice(variant.id);
      console.log('$firstADPrice',$firstADPrice);
      console.log('$recurringADPrice',$recurringADPrice);
      console.log('canbeAutoDelivered',canbeAutoDelivered);
      console.log('recurringADPrice',slate.Currency.formatMoney(recurringADPrice, theme.moneyFormat));
      if (variant) {
        console.log('variant found');

        const maxSavings = $ogMaxSavings.data('max-savings');
        if(maxSavings && $ogMaxSavingsContainer) {
          $ogMaxSavingsContainer.text(maxSavings);
        }

        $productMsrp.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $productPrice.removeClass(classes.hide);
        $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        $rcComparePrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        $ogComparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));

        if (canbeAutoDelivered) {
          console.log('canbeAutoDelivered updatePrices running');
          $firstADComparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $recurringADComparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $firstADPrice.html(slate.Currency.formatMoney(firstADPrice, theme.moneyFormat));
          $recurringADPrice.html(slate.Currency.formatMoney(recurringADPrice, theme.moneyFormat));
        }
        if (variant.compare_at_price > variant.price) {
          console.log('updatePrices variant.compare_at_price > variant.price running');
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.removeClass(classes.hide);
          $ogOnetimePriceWrapper.addClass(classes.isOnSale);
          $rcComparePrice.addClass(classes.visualHide);
          $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
          $productPrice.addClass('u-color-onp-green-alt');
          $atcPrice.addClass('u-color-onp-red');
        } else {
          console.log('updatePrices last else running');
          $comparePrice.html('');
          $compareEls.addClass(classes.hide);
          $ogOnetimePriceWrapper.removeClass(classes.isOnSale);
          $rcComparePrice.addClass(classes.visualHide);
          $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
          $productPrice.removeClass('u-color-onp-green-alt');
          $atcPrice.removeClass('u-color-onp-red');
        }
      } else {
        console.log('variant not found');
        // Variant doesn't exist, hide prices.
        $productPrice.addClass(classes.hide);
        $compareEls.addClass(classes.hide);
      }

      if (window.orderGrooveAutoDelivery?.hideAuto) {
        $productPrice.addClass(classes.hide);
        $ogInitialDiscount.addClass(classes.hide);
        $ogSubscriptionPriceWrapper.html('<span class="view-in-cart">view price in cart</span>');
      }

      let isSubscribed = $(selectors.ogSubscribedSelector).length;
      if (isSubscribed) {
        this.updateAtcButtonStyles({ optedIn: true })
      }

      this.updateServings();
    },

    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantOptionValues: function(variant) {
      if (variant) {
        // Loop through all the options and update the option value
        for (var i = 1; i <= 3; i++) {
          var variantOptionValue = variant['option' + i];

          if (!variantOptionValue) break; // Break if the product doesn't have an option at this index

          // update the text in the label with the selected variant's value
          var $productOptionTitle = $('[data-selected-variant-option-display="' + i + '"]', this.$container);
          $productOptionTitle.text(variantOptionValue);

          if (i === 1) {
            // update the title with the first variant option's selected value
            var $productTitle = $(selectors.productTitleVariant, this.$container);
            $productTitle.text(variantOptionValue);
          }

          // Since we are finding the variantOptionValueUI based on the *actual* value, we need to scope to the correct list
          // As some products can have the same values for different variant options (waist + inseam both use "32", "34", etc..)
          // var $variantOptionValueList = $(selectors.variantOptionValueList, this.$container).filter('[data-option-position="'+i+'"]');
          // var $variantOptionValueUI = $('[data-variant-option-value="'+variantOptionValue+'"]', $variantOptionValueList);

          // $variantOptionValueUI.addClass( classes.variantOptionValueActive );
          // $variantOptionValueUI.siblings().removeClass( classes.variantOptionValueActive );

        }
      }
    },

    /**
     * Look for a gallery matching one of the selected variant's options and switch to that gallery
     * If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     */
    updateGalleries: function(variant) {

      var $galleries = $(selectors.productGallery, this.$container);

      function getVariantGalleryForOption(option) {
        return $galleries.filter(function() {
          return $(this).data('variant-gallery') == option;
        });
      }

      if (variant) {
        if ($galleries.length > 1) {
          for (var i = 3; i >= 1; i--) {
            var $variantGallery = getVariantGalleryForOption(variant['option' + i]);
            if ($variantGallery.length && $variantGallery.hasClass(classes.hide)) {
              $galleries.not($variantGallery).addClass(classes.hide);
              $variantGallery.removeClass(classes.hide);
              // Slick needs to make a lot of measurements in order to work, calling `refresh` forces this to happen
              $variantGallery.find(selectors.productGallerySlideshow).resize().slick('getSlick').refresh();
              $variantGallery.find(selectors.productGalleryThumbnails).resize().slick('getSlick').refresh();
            }
          }
        }
        else {
          // $galleries is just a single gallery
          // Slide to featured image for selected variant but only if we're not already on it.
          // Have to check this way because slick clones slides so even if we're currently on it, there can be a cloned slide that also has the correct data-image attribute
          if (variant.featured_image && $galleries.find('.slick-current').data('image') != variant.featured_image.id) {
            var $imageSlide = $galleries.find('[data-image="' + variant.featured_image.id + '"]').first();

            if ($imageSlide.length) {
              $galleries.find(selectors.productGallerySlideshow).slick('slickGoTo', $imageSlide.data('slick-index'));
            }
          }
        }
      }
      else {
        // No variant - Don't do anything?
      }
    },

    updateBadges: function(variant) {
      var $galleryEyebrow = $(selectors.productCardEyebrow, this.$container);
      // Show the badge in the case there's any set
      $galleryEyebrow.show();
      var productTags = this.productSingleObject.tags;
      var hideSaleBadge = this.productSingleObject.metafields.hide_sale_badge;
      var badgeTag = "";
      $.each(productTags, function(index, tag) {
        if (badgeTag == "") {
          if (tag.indexOf('Badge:') > -1 || tag.indexOf('badge:') > -1) {
            badgeTag = tag.replace('Badge:', "").replace('badge:', "");
          }
        }
      });
      if (variant.metafields.variant_badge != null) {
        $galleryEyebrow.text(variant.metafields.variant_badge);
      } else if (badgeTag != "") {
        $galleryEyebrow.text(badgeTag);
      } else if (variant.compare_at_price > variant.price && hideSaleBadge != 1) {
        $galleryEyebrow.text('Sale').addClass('product-card__eyebrow--sale');
      } else if (productTags.indexOf('Features:Staff Picks') > -1) {
        $galleryEyebrow.text('Staff Picks');
      } else if (productTags.indexOf('Features:New Arrivals') > -1) {
        $galleryEyebrow.text('New Arrivals');
      } else {
        // Hide the badge if there's nothing to show
        $galleryEyebrow.hide();
      }
    },

    /**
     * Method to update the Order Groove subscription widget.
     */
    updateOgWidget: function (/* variant */) {
      var originalSelectElment = document.querySelector(`#product-select-${this.productSingleObject.id}`);
      if (originalSelectElment) {
        originalSelectElment.dispatchEvent(new Event('change'));
      }
    },

    /**
     * Update the available quantity of a variant based on a new selected variant
     * @param {Object} variant - Shopify variant object
     */
    updateAvailableQuantity: function(variant) {
      const $quantityAvailbleWrapper = $(selectors.quantityAvailableWrapper, this.$container);
      const $quantityAvailble = $(selectors.quantityAvailable, this.$container);

      if (!$quantityAvailbleWrapper || !$quantityAvailble || !variant) {
        return;
      }

      if (variant.inventory_quantity > 6) {
        $quantityAvailbleWrapper.addClass(classes.hide);
      } else {
        $quantityAvailbleWrapper.removeClass(classes.hide);
      }

      $quantityAvailble.html(variant.inventory_quantity > 0 ? variant.inventory_quantity : 0);

      this.handleQuantitySelectorVisibility(variant.inventory_quantity);
    },

    /**
     * Handle variant option value click event.
     * Update the associated select tag and update the UI for this value
     *
     * @param {event} evt
     */
    onVariantOptionValueClick: function(e) {
      var $option = $(e.currentTarget);

      if ($option.hasClass(classes.variantOptionValueActive)) {
        return;
      }

      var value = $option.data('variant-option-value');
      var position = $option.parents(selectors.variantOptionValueList).data('option-position');
      var $selector = $(selectors.singleOptionSelector, this.$container).filter('[data-index="option' + position + '"]');

      $selector.val(value);
      $selector.trigger('change');

      $option.addClass(classes.variantOptionValueActive);
      $option.siblings().removeClass(classes.variantOptionValueActive);

    },

    checkAutoshipEligible(variantId) {
      return window.og && window.og.store ? window.og.store.getState().autoshipEligible[variantId] : false;
    },

    /**
     * Runs when the OG widget is toggled between one-time / subscription states.
     *
     * @param {Object} changedState - { productId, optedIn }
     */
    onSubscriptionToggleChange: function (changedState) {
      var productId = changedState.productId;
      var subscriptionPrice = this.getFirstADPrice(productId);
      //this.updateProductPrices(this.variants.currentVariant, changedState.optedIn);
      this.updateAddToCartBtnPrice(this.variants.currentVariant, changedState.optedIn, slate.Currency.formatMoney(subscriptionPrice, theme.moneyFormat));
      this.handleOfferIncentivesVisibility(changedState);
      this.updateServings();
      this.updateAtcButtonStyles(changedState);
    },

    /**
     * Check if the offer incentives should be visible based on optin state.
     */
    handleOfferIncentivesVisibility: function(changedState) {
      const $elem = $(selectors.ogOfferIncentives, this.$container);

      if (!$elem.length) {
        return;
      }

      if (typeof changedState?.optedIn === 'undefined' || changedState.optedIn) {
        $elem.removeClass(classes.hide);
      } else {
        $elem.addClass(classes.hide);
      }
    },

    /**
     * getFirstADPrice
     * @param {String} productId - actually a variant ID, but OrderGroove changedState object calls it this.
     * @returns {String|Null} - the subscription price, already formatted.
     */
    getFirstADPrice(variantId) {
      let firstADPrice = window.variantPricing.prices[variantId].firstADPrice;
      if(this.isReturningSubscriber()){
        firstADPrice = window.variantPricing.prices[variantId].recurringADPrice;
      }
      return firstADPrice;
      /*
      var offerElement = document.querySelector(".product-detail-form-container og-offer");

      if (!offerElement) {
        return null;
      }

      var productPlanSelected = offerElement.getAttribute('frequency');

      let productPlanSelectedInit = $('og-select-frequency > option[selected]', this.$container);
      if (productPlanSelectedInit) {
        productPlanSelectedInit = productPlanSelectedInit[0].value
      }

      if (window.og && window.og.store) {
        var productPlans = og.store.getState().productPlans[productId];
        let productPlanNumbers = [];

        productPlans.forEach(function(productPlan) {
            if (productPlan['frequency'] == productPlanSelected || productPlan['frequency'] == productPlanSelectedInit) {
              productPlanNumbers = productPlan;
            }
        });
        var subscriptionPrice = productPlanNumbers && Object.keys(productPlanNumbers).length ? productPlanNumbers['subscriptionPrice'] : null;
        return subscriptionPrice;
      }
      return null;
      */
    },

    isReturningSubscriber() {
      isReturningSubscriber = window.variantPricing.buyerIdentity.returningSubscriber || false;
      return isReturningSubscriber;
    },

    getFirstDiscountPercentage(variantId) {
      firstDiscountPercentage = window.variantPricing.prices[variantId].firstDiscountPercentage;
      return firstDiscountPercentage;
    },

    getRecurringDiscountPercentage(variantId) {
      recurringDiscountPercentage = window.variantPricing.prices[variantId].recurringDiscountPercentage;
      return recurringDiscountPercentage;
    },

    getRecurringADPrice(variantId){
      recurringPrice = window.variantPricing.prices[variantId].recurringADPrice;
      return recurringPrice;
    },

    updateServings() {
      const currentVariant = this.variants.currentVariant
      const $servingPrice = $(selectors.servingPrice, this.$container);

      if (!currentVariant?.metafields?.serving_amount || !currentVariant?.metafields?.serving_type) {
        $servingPrice.addClass(classes.hide);
        return;
      }

      $servingPrice.removeClass(classes.hide);

      const $addToCartPrice = $(selectors.addToCartPrice, this.$container);
      const price = parseFloat($addToCartPrice.html().replace(/[^0-9.-]+/g, ''));
      const servingAmount = parseFloat(currentVariant.metafields.serving_amount);
      const servingType = currentVariant.metafields.serving_type;
      const servingPrice = price / servingAmount;

      $servingPrice.html(`$${servingPrice.toFixed(2)}/${servingType}`);
    },

    updateAtcButtonStyles({ optedIn }) {
      var $addToCartBtn = $(selectors.addToCart, this.$container);
      if (optedIn) {
        $addToCartBtn.addClass(classes.addToCartButtonSubscribed);
      } else {
        $addToCartBtn.removeClass(classes.addToCartButtonSubscribed);
      }
    },

    hideOgInitialDiscountElem() {
      const $ogInitialDiscount = $(selectors.ogInitialDiscount, this.$container);
      if ($ogInitialDiscount) {
        $ogInitialDiscount.hide();
      }
    },

    handleInitialDiscountElems(variant) {
      const $ogInitialDiscount = $(selectors.ogInitialDiscount, this.$container);
      const ogState = OG.store.getState()
      const currentVariant = variant || this.variants.currentVariant;
      const plans = ogState.productPlans[currentVariant.id]

      if (!plans) return;

      const discount = parseFloat(plans[0]?.discountRate || 0)
      if (discount < 1) {
        $ogInitialDiscount.hide();
      } else {
        $ogInitialDiscount.show();
      }
    },

    handleQuantitySelectorVisibility: function(quantity) {
      const $quantitySelect = $(selectors.quantitySelectorWrapper, this.$container);
      if (quantity === 0) {
        $quantitySelect.addClass(classes.hide);
      } else {
        $quantitySelect.removeClass(classes.hide);
      }
    }

  });

  return ProductDetailForm;

})(jQuery, Modernizr, slate);

/**
 * Quantity Adjuster Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the quantity adjuster component
 *
 *  [data-quantity-adjuster]
 *    [data-increment]
 *    input[type="number"]
 *    [data-decrement]
 *
 */

slate.quantityAdjuster = (function() {

  var selectors = {
    adjuster: '[data-quantity-adjuster]',
    increment: '[data-increment]',
    decrement: '[data-decrement]',
    input: 'input[type="number"]'
  };

  /**
   * Quantity Adjuster Constructor
   *
   * @param {HTMLElement | jQuery} el - element, either matching selectors.adjuster or a child element
   */
  function QuantityAdjuster(el) {

    this.name = 'quantityAdjuster';
    this.namespace = '.' + this.name;

    this.$el = $(el).is(selectors.adjuster) ? $(el) : $(el).parents(selectors.adjuster);

    if (!this.$el) {
      console.warn('[' + this.name + '] - Element required to initialize');
      return;
    }

    this.$increment = $(selectors.increment, this.$el);
    this.$decrement = $(selectors.decrement, this.$el);
    this.$input = $(selectors.input, this.$el);

    this.$increment.on('click', this.onIncrementClick.bind(this));
    this.$decrement.on('click', this.onDecrementClick.bind(this));
    this.$input.on('change', this.onInputChange.bind(this));

    this._addMutationObserver(this.$input.get(0));

    this._updateDisabledState();
  }

  QuantityAdjuster.prototype = {

    _getMin: function() {
      return parseInt(this.$input.attr('min')) || 0;
    },

    _getMax: function() {
      return parseInt(this.$input.attr('max')) || 999;
    },

    _addMutationObserver: function(el) {
      if (!el) return;

      var observer;
      var config = { attributes: true };
      var self = this;

      observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type == "attributes") {
            if (mutation.attributeName == "max" || mutation.attributeName == "min") {
              self.onMinMaxAttributeChange();
            }
            else if (mutation.attributeName == "disabled") {
              self.onDisabledAttributeChange();
            }
          }
        });
      });

      observer.observe(el, config);
    },

    _updateDisabledState: function() {
      var val = parseInt(this.$input.val());

      if (this.$input.is(':disabled')) {
        this.$increment.prop('disabled', true);
        this.$decrement.prop('disabled', true);
      } else {
        if (val == this._getMax() && val == this._getMin()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', true);
        }
        else if (val >= this._getMax()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', false);
        }
        else if (val <= this._getMin()) {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', true);
        }
        else {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', false);
        }
      }
    },

    _changeValue: function(amount) {

      if (this.$input.is(':disabled') || typeof amount == "undefined") return;

      amount = parseInt(amount);

      var val = parseInt(this.$input.val());
      var newVal = val + amount;

      // Don't change if the value is the same or invalid
      if (newVal == val || newVal > this._getMax() || newVal < this._getMin()) return;

      this.$input.val(newVal);
      this.$input.trigger('change');
    },

    _clampInputVal: function() {
      var currVal = parseInt(this.$input.val());
      var max = this._getMax();
      var min = this._getMin();

      if (currVal > max) {
        this.$input.val(max);
      }
      else if (currVal < min) {
        this.$input.val(min);
      }
    },

    onDisabledAttributeChange: function() {
      this._updateDisabledState();
    },

    onMinMaxAttributeChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onInputChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onIncrementClick: function(e) {
      e.preventDefault();
      this._changeValue(1);
    },

    onDecrementClick: function(e) {
      e.preventDefault();
      this._changeValue(-1);
    }
  };

  // End prototype

  // QA DATA-API
  // ===========

  var dataKey = 'quantity-adjuster';

  function ensureQuantityAdjuster(el) {
    var $el = $(el);

    if (!$el.is(selectors.adjuster)) {
      $el = $el.parents(selectors.adjuster);
    }

    var data = $el.data(dataKey);

    if (!data) {
      $el.data(dataKey, (data = new QuantityAdjuster($el)));
    }

    return data;
  }

  // Check all adjuster elements on the page and initialize them if necessary
  function refresh() {
    $(selectors.adjuster).each(function(i, el) {
      ensureQuantityAdjuster(el);
    });
  }

  $(function() {

    refresh();

    $(document)
      .on('shopify:section:load', refresh)
      .on('shopify:section:unload', refresh)
      .on('shopify:section:select', refresh)
      .on('shopify:section:deselect', refresh)
      .on('shopify:section:reorder', refresh)
      .on('shopify:block:select', refresh)
      .on('shopify:block:deselect', refresh);
  });

  return {
    refresh: refresh
  };

}());

/**
 * Forms Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with forms on the site
 */

slate.forms = (function($) {

  var selectors = {
    formControl: '.form-control',
    formGroup: '.form-group',
    chosen: '.chosen-container'
  };

  var classes = {
    formGroupIsFocused: 'is-focused',
    formGroupHasError: 'has-error'
  };

  var $body = $(document.body);

  var initialized = false;

  function onFormControlFocus(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup = $formControl.parents(selectors.formGroup);

    $formGroup.addClass(classes.formGroupIsFocused);
  }

  function onFormControlBlur(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupIsFocused);
  }

  function removeFormControlErrorState(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupHasError);
  }

  function onChosenShowingDropdown(e) {
    onFormControlFocus(e);
  }

  function onChosenHidingDropdown(e) {
    onFormControlBlur(e);
  }

  function initialize() {
    if (initialized) return;

    $body.on('focus', selectors.formControl, onFormControlFocus);
    $body.on('blur', selectors.formControl, onFormControlBlur);
    $body.on('change keydown', selectors.formControl, removeFormControlErrorState);
    $body.on('chosen:showing_dropdown', selectors.formControl, onChosenShowingDropdown);
    $body.on('chosen:hiding_dropdown', selectors.formControl, onChosenHidingDropdown);

    initialized = true;

    return initialized;
  }

  return {
    initialize: initialize
  };

}(jQuery));

/**
 * Back To Top Button
 * ------------------------------------------------------------------------------
 *
 * JS functionality for `[data-back-to-top]`
 *
 *
 * @namespace - backToTop
 */
slate.BackToTop = (function($) {
  var $window = $(window);

  var selectors = {
    backToTop: "[data-back-to-top]"
  };

  var classes = {
    hidden: "hidden"
  };

  var defaults = {
    appearThreshold: 300,
    animateDuration: 500,
    animationEasing: "swing",
    animationComplete: $.noop
  };

  function BackToTop($el, options) {
    this.$container = $el;
    this.settings = $.extend({}, defaults, options);

    this.toggleButton();
    $window.on('scroll', this.toggleButton.bind(this));
    this.$container.on("click", this.scrollToTop.bind(this));
  }

  BackToTop.prototype = $.extend({}, BackToTop.prototype, {
    toggleButton: function() {
      if ($window.scrollTop() > this.settings.appearThreshold) {
        this.show();
      } else {
        this.hide();
      }
    },

    show: function() {
      this.$container.removeClass(classes.hidden);
    },

    hide: function() {
      this.$container.addClass(classes.hidden);
    },

    /**
     * Scrolls to the top of the page
     * @param {*} e 
     */
    scrollToTop: function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, {
        duration: this.settings.animateDuration,
        easing: this.settings.animationEasing,
        complete: this.settings.animationComplete
      });
    }
  });

  // init back to top button
  $(document).ready(function() {
    var $backToTop = $(selectors.backToTop);

    new BackToTop($backToTop);
  });

  return BackToTop;
})(jQuery);

slate.ordergrooveEnrollment = (function($) {
  const selectors = {
    frequencySelector: 'og-select-frequency, og-optin-select',
    incentiveText: 'og-incentive-text',
    offerWidget: 'og-offer',
    selectInput: 'og-select',
    OgPrice: 'og-offer #rc_label__autodeliver-price',
    OgMessage1: 'og-offer #rc_label__autodeliver-message-1',
    OgMessage2: 'og-offer #rc_label__autodeliver-message-2',
    buttonPrice: '.btn-primary [data-add-to-cart-price]',
    ogSubscribedSelector: 'og-offer .rc_block__type__autodeliver og-optin-button[subscribed]'
  };
  const autoDeliverytag = "AD_default";
  /**
   * Object containing the frequencies we want to remove if a product has a specific tag. The keys in this object are product tags and the
   * values corresponds to the specific frequencies values we want to remove for each tag. E.g.
   * {
   *    test_tag: "16_2,8_2",
   *    flea_product: "16_2",
   *    default: "6_2"
   * }
   *
   * For the example above, if a product has a "test_tag" tag we need to remove the 16_2 and the 8_2 frequencies from the frequency selector.
   * If a product has a "flea_product" tag we need to remove only the 16_2 frequency.
   * If a product has both "test_tag" and "flea_product" tags we need to remove the 16_2 and the 8_2 frequencies.
   * If a product doesn't have any of the tags in this object we need to remove whatever frequencies the "default" key has.
   */
  const tagsFrequenciesToRemoveMap = {
    AD_12month: '2_2,4_2,6_2,8_2,10_2,12_2,16_2',
    default: '12_3',
  }
  const tagToRemoveIncentiveText = 'AD_0percent';

  /**
   * Method that adds additional functionalities to Ordergroove's frequency selector.
   *
   * For each frequency selector (there should be only 1 but iterating just in case) we get the actual HTML select input and if it exists,
   * we get all the HTML option elements and for each one of them we call the functionality we need.
   *
   * @param {HTMLElement} container The HTML wrapper
   * @param {Object} product The product object
   */
  function handleFrequencySelector(container, product) {
    const frequencySelectors = $(selectors.frequencySelector, container);

    const OgPriceElement = $(selectors.OgPrice, container);
    const OgMessage1Element = $(selectors.OgMessage1, container);
    const OgMessage2Element = $(selectors.OgMessage2, container);
    const buttonPriceElement = $(selectors.buttonPrice);
    const isSubscribed = $(selectors.ogSubscribedSelector).length;

    if (window.orderGrooveAutoDelivery && OgPriceElement) {
      if (window.orderGrooveAutoDelivery.hideAuto) {
        OgPriceElement.hide();
        if (isSubscribed) {
          buttonPriceElement.hide();
        }
      }

    }

    if (window.orderGrooveAutoDelivery && OgMessage1Element) {
      if (window.orderGrooveAutoDelivery.message1 !== "") {
        OgMessage1Element.html('<strong>' + window.orderGrooveAutoDelivery.message1 + '</strong>').show();
      }
      if (window.orderGrooveAutoDelivery.hideMessage1) {
        OgMessage1Element.hide();
      }
    }

    if (window.orderGrooveAutoDelivery && OgMessage2Element) {
      if (window.orderGrooveAutoDelivery.message2 !== "") {
        OgMessage2Element.html(window.orderGrooveAutoDelivery.message2).show();
      }
      if (window.orderGrooveAutoDelivery.hideMessage2) {
        OgMessage2Element.hide();
      }
    }


    [...frequencySelectors].forEach((selector) => {
      const selectInput = selector.shadowRoot.querySelector(selectors.selectInput);

      if (selectInput) {
        const frequencySelectorOptions = selectInput.shadowRoot.querySelectorAll('option');
        const frequenciesToRemove = getFrequenciesToRemove(product);

        [...frequencySelectorOptions].forEach((option) => {
          addStylesToFrequencyOption(option)
          removeFrequencyOption(frequenciesToRemove, option)
        });
      }
    });
  }

  function addStylesToFrequencyOption(option) {
    option.style.color = 'black';
    option.style.fontWeight = '800';
  }

  /**
   * Method that gets the frequencies we need to remove from a certain product.
   *
   * If the product has a tag that matches one of the tags in tagsFrequenciesToRemoveMap, we need to iterate over those tags and add all
   * the frequencies we need to remove to a single array. If it doesn't, then we need to remove the frequencies of the "default" key.
   * We return a single array with all the frequencies we need to remove (e.g. ['16_2', '8_2']).
   *
   * @param {Object} product The current product object
   * @returns { Array } The OG frequency values we need to remove (16_2, 8_2, etc).
   */
  function getFrequenciesToRemove(product) {
    let frequenciesToRemove = [];
    const productTags = product.tags;
    const productHasTagWithFrequenciesToRemove = Object.keys(tagsFrequenciesToRemoveMap).some((tag) => productTags.includes(tag))

    if (productHasTagWithFrequenciesToRemove) {
      Object.keys(tagsFrequenciesToRemoveMap).forEach((tag) => {
        if (productTags.includes(tag)) {
          const frequenciesInTag = tagsFrequenciesToRemoveMap[tag].split(',');
          frequenciesToRemove = [...frequenciesToRemove, ...frequenciesInTag];
        }
      });
    } else {
      const frequenciesInTag = tagsFrequenciesToRemoveMap.default.split(',');
      frequenciesToRemove = [...frequenciesToRemove, ...frequenciesInTag];
    }

    return frequenciesToRemove;
  }

  /**
   * Method that removes a frequency from OG's frequency selector only if that option exists and if its value is included in an array.
   *
   * @param {Array} frequenciesToRemove The OG frequencies we need to remove
   * @param {HTMLOptionElement} option The option HTML element inside OG's frequency selector select input
   */
  function removeFrequencyOption(frequenciesToRemove, option) {
    if (option) {
      if (frequenciesToRemove.includes(option.value)) {
        option.remove();
      } else {
        const ogText = option.querySelector('og-text');
        const variant = ogText && ogText.attributes && ogText.attributes.variant
            ? ogText.attributes.variant.value
            : null;
        const pluralize = ogText && ogText.attributes && ogText.attributes.pluralize
            ? ogText.attributes.pluralize.value
            : null;
        const optionFrequencyValue = `${pluralize}_${variant}`;
        if (pluralize && variant && frequenciesToRemove.includes(optionFrequencyValue)) {
          option.remove();
        }
      }
    }
  }

  /**
   * Function that makes a selection on Ordergroove's enrollment widget based on the URL search params. If the URL has a search
   * param of type=subscription then we will need to select the subscription in the widget, if not then we will need to select
   * "one time purchase" as subscription type. To do that we are using the dispatch method of Ordergroove, for that we need
   * the variant ID of the current product and the frequency of the subscription, which we obtain based on which option is selected
   * by default in the frequency selector
   *
   * @param {HTMLElement} container
   * @param {Number} variantId
   */
  function preSelectSubscription(container, variantId, product) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const userIsSubscribing = urlSearchParams.get('type') === 'subscription';
    const ogFrequencyElement = container[0].querySelector(selectors.frequencySelector);

    if (window.og && ogFrequencyElement) {
      const frequenciesWrapper = ogFrequencyElement.shadowRoot.querySelector(selectors.selectInput);

      if (!frequenciesWrapper) {
        return;
      }

      const frequencies = frequenciesWrapper.shadowRoot.querySelectorAll('option');
      const defaultFrequency = [...frequencies].find((item) => item.selected);

      if (!defaultFrequency) {
        return;
      }
      const productInfo = {
        product: {
          id: variantId.toString(),
        },
        frequency: defaultFrequency.value
      }

      if (userIsSubscribing) {
        const subscriptionIsSelected = window.og.store.getState().optedin.some((item) => item.id === variantId.toString());
        dispatchOGSubscription('OPTIN_PRODUCT', productInfo, subscriptionIsSelected);
      }

      const tags = product.tags;
      const subscribeDefault = tags.includes(autoDeliverytag);

      if (subscribeDefault) {
        const oneTimePurchaseIsSelected = window.og.store.getState().optedout.some((item) => item.id === variantId.toString());
        dispatchOGSubscription('OPTOUT_PRODUCT', productInfo, oneTimePurchaseIsSelected);

        setTimeout(function() {
          const subscriptionIsSelected = window.og.store.getState().optedin.some((item) => item.id === variantId.toString());
          dispatchOGSubscription('OPTIN_PRODUCT', productInfo, subscriptionIsSelected);
        }, 800);
      }

    }
  }

  function dispatchOGSubscription(type, payload, typeIsSelected) {
    if (!typeIsSelected) {
      window.og.store.dispatch({
        type,
        payload
      });
    }
  }

  function removeIncentiveText(productTags, container) {
    if (!container) {
      return
    }
    console.log('container',container);
    /*
    const offerWidget = container.querySelector(selectors.offerWidget);
    */
    console.log('productTags in removeIncentiveText',productTags);
    /*
    if (!offerWidget) {
      return;
    }
    */
    const incentiveElement = container.querySelector(selectors.incentiveText);
    const shouldRemoveIncentiveText = productTags.includes(tagToRemoveIncentiveText);
    console.log('shouldRemoveIncentiveText',shouldRemoveIncentiveText);

    console.log('incentiveElement',incentiveElement);
    if (incentiveElement && shouldRemoveIncentiveText) {
      if (incentiveElement.parentElement.parentElement) {
        incentiveElement.parentElement.parentElement.style.display = 'none';
      }
    }
  }

  return { handleFrequencySelector, preSelectSubscription, removeIncentiveText, removeFrequencyOption, getFrequenciesToRemove };
})(jQuery);


/**
 * Model - Dropdown
 * -----------------------------------------------------------------------------
 * Dropdowns are just elements that respond to a visibility class in order to hide and show
 *
 * @namespace models.dropdown
 */

slate.models = slate.models || {};

slate.models.Dropdown = (function($) {

  var classes = {
    open: 'is-open',
    forcedOpen: 'is-forced-open',
    active: 'is-active'
  };

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element with attributes 'data-dropdown-trigger' and 'data-block'
   */
  function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el = $(this.$trigger.data('dropdown-trigger'));
    this.blockId = this.$trigger.data('block').toString();
  }

  Dropdown.prototype = {
    isOpen: function() {
      return this.$el.hasClass(classes.open);
    },

    open: function() {
      this.$trigger.addClass(classes.active);
      this.$el.addClass(classes.open);
    },

    close: function() {
      this.$trigger.removeClass(classes.active);
      this.$el.removeClass(classes.open);
    },

    /**
     * Dropdown manager doesn't use the forced open class
     * So we can use it in conjunction with the theme editor to ensure dropdowns are open while editing
     */
    forceOpen: function() {
      this.$el.addClass(classes.forcedOpen);
    },

    forceClose: function() {
      this.$el.removeClass(classes.forcedOpen);
    }
  };

  return Dropdown;

}(jQuery));

/**
 * Model - DropdownManager
 * -----------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.models.Dropdown
 *  - slate.utils
 *
 * @namespace models.DropdownManager
 */

slate.models = slate.models || {};

slate.models.DropdownManager = (function($) {

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function DropdownManager() {

    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 80;
    this.dropdowns = [];
    this.activeDropdown = undefined;

    this.events = window.PointerEvent ? {
      end: "pointerup",
      enter: "pointerenter",
      leave: "pointerleave"
    } : {
      end: "touchend",
      enter: "mouseenter",
      leave: "mouseleave"
    };

  }

  DropdownManager.prototype = {
    register: function($trigger) {
      var dd = new slate.models.Dropdown($trigger);

      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(this.events.enter, this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(this.events.leave, this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(this.events.end, this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(this.events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(this.events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(this.events.end, this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);
    },

    getDropdownByBlockId: function(id) {
      return slate.utils.findInstance(this.dropdowns, 'blockId', id);
    },

    onTriggerMouseEnter: function(dd, e) {
      if (e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },

    onTriggerMouseLeave: function(dd, e) {
      if (e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },

    onTriggerTouchEnd: function(dd, e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },

    onDropdownMouseEnter: function(dd, e) {
      if (e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },

    onDropdownMouseLeave: function(dd, e) {
      if (e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },

    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },

    toggleDropdown: function(dd) {
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },

    openDropdown: function(dd) {
      if (this.activeDropdown !== dd) {
        this.activeDropdown = dd;
        this.closeAllDropdowns();
        dd.open();
      }
    },

    closeDropdown: function(dd) {
      dd.close();

      if (this.activeDropdown == dd) {
        this.activeDropdown = undefined;
      }
    },

    closeAllDropdowns: function() {
      $.each(this.dropdowns, function(i, dd) {
        if (dd.isOpen()) {
          dd.close();
        }
      });
      this.activeDropdown = undefined;
    },

    startCloseTimeout: function(dd) {
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },

    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    }
  };

  return DropdownManager;

}(jQuery));

/**
 * Drawer
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Drawer
*/

slate.models = slate.models || {};

slate.models.Drawer = (function($, Modernizr) {

  var $document = $(document);
  var $body = $(document.body);

  var selectors = {
    close: '[data-drawer-close]',
    panelSlide: '[data-drawer-panel-slide]',
    panelSlideDismiss: '[data-drawer-panel-slide-dismiss]',
    panelSlideTrigger: '[data-drawer-panel-slide-trigger]'
  };

  var classes = {
    drawer: 'drawer',
    visible: 'is-visible',
    backdrop: 'drawer-backdrop drawer-backdrop--mobile-nav',
    bodyDrawerOpen: 'drawer-open',
    panelSlideActive: 'is-active'
  };

  /**
  * Drawer constructor
  *
  * @param {HTMLElement | $} el - The drawer element
  */
  function Drawer(el) {

    this.name = 'drawer';
    this.namespace = '.' + this.name;

    this.$el = $(el);
    this.$close = null;
    this.stateIsOpen = false;
    this.transitionEndEvent = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if (this.$el == undefined || !this.$el.hasClass(classes.drawer)) {
      console.warn('[' + this.name + '] - Element with class `' + classes.drawer + '` required to initialize.');
      return;
    }

    this.events = {
      HIDE: 'hide' + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW: 'show' + this.namespace,
      SHOWN: 'shown' + this.namespace
    };

    this.$el.on('click', selectors.panelSlideTrigger, this.onPanelSlideTriggerClick.bind(this));
    this.$el.on('click', selectors.panelSlideDismiss, this.onPanelSlideDismissClick.bind(this));
    this.$el.on('click', selectors.close, this.onCloseClick.bind(this));
  }

  Drawer.prototype = $.extend({}, Drawer.prototype, {
    addBackdrop: function(callback) {
      var cb = callback || $.noop;

      if (this.stateIsOpen) {
        this.$close = $(document.createElement('div'));
        this.$close.one('click', this.hide.bind(this));

        setTimeout(function() {
          $body.addClass(classes.bodyDrawerOpen);
        }, 30);
      }
      else {
        cb();
      }
    },

    removeBackdrop: function() {
      $body.removeClass(classes.bodyDrawerOpen);
    },

    /**
     * Called after the closing animation has run
     */
    onHidden: function() {
      this.$el.find(selectors.panelSlide).removeClass(classes.panelSlideActive); // Hide any active slide panels
      this.stateIsOpen = false;
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if (!this.stateIsOpen) return;

      this.$el.removeClass(classes.visible);

      this.removeBackdrop();

      if (this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if (this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      this.addBackdrop();

      if (this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    },

    onPanelSlideTriggerClick: function(e) {
      e.preventDefault();
      $(e.currentTarget.getAttribute('href')).addClass(classes.panelSlideActive);
    },

    onPanelSlideDismissClick: function(e) {
      e.preventDefault();
      $(e.currentTarget).closest(selectors.panelSlide).removeClass(classes.panelSlideActive);
    },
  });

  // DRAWER DATA-API
  // ===============

  $document.on('click.drawer', '[data-toggle="drawer"]', function(e) {

    var $this = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data = $this.data('drawer');

    if ($this.is('a')) e.preventDefault();

    if (!data) {
      $this.data('drawer', (data = new Drawer($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });

  return Drawer;

}(jQuery, Modernizr));

/**
 * Slideshow
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.Slideshow
*/

slate.models = slate.models || {};

slate.models.Slideshow = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

  var KEYS = {
    left: 37,
    right: 39
  };

  /**
   * Slideshow constructor
   *
   * @param {HTMLElement | $} el - The actual slideshow element
   * @param {Object} options - Options passed into the slider initialize function
   */
  function Slideshow(el, options) {

    var $el = $(el);

    this.$slideshow = $el;
    this.$wrapper = $el.closest(selectors.slideShowWrapper);

    if (!this.$slideshow.length) {
      console.warn('[' + this.name + '] - Slideshow element required to initialize');
      return;
    }

    var fade = this.$slideshow.attr('data-fade') && this.$slideshow.attr('data-fade').length ? this.$slideshow.data('fade') : true; // Allows us to pass data-fade="false".  $.fn.attr coerces to string, $.fn.data does *not*

    var defaults = {
      accessibility: false, // prevents page from jumping on focus
      arrows: !Modernizr.touchevents,
      dots: this.$slideshow.data('dots'),
      fade: fade,
      draggable: true,
      touchThreshold: 20,
      slidesToShow: this.$slideshow.data('slides-to-show') || 1,
      slidesToScroll: this.$slideshow.data('slides-to-scroll') || 1,
      autoplay: this.$slideshow.data('autoplay') || false,
      autoplaySpeed: this.$slideshow.data('speed') || 5000,
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--right"><span class="arrow__icon"></span></span></div>',

      // Options below here are not used in slick
      equalHeightSlides: this.$slideshow.data('equal-heights') || false
    };

    this.settings = $.extend({}, defaults, options);

    // Turn off dots if there's only one slide
    if (this.$slideshow.children().length <= 1) {
      this.settings.dots = false;
    }

    // this.$slideshow.on('init', this.slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    if (this.settings.equalHeightSlides) {
      this.$slideshow.addClass('has-equal-height-slides');
    }
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Adds events to the slideshow for improved accessibility
     *
     * @param {Event} evt - window event w/ type "init"
     * @param {Object} slick
     */
    slideshowA11y: function(evt, slick) {
      var self = this;
      var $list = slick.$list;
      var $dots = slick.$dots;
      var $wrapper = this.$wrapper;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      $wrapper.on('focusin', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');

        if (autoplay) {
          self.pause();
        }
      });

      // Resume autoplay
      $wrapper.on('focusout', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');

        if (autoplay) {
          self.play();
        }
      });

      // Add arrow key support when focused
      if ($dots) {
        $dots.on('keydown', function(evt) {
          if (evt.which === KEYS.left) {
            self.prev();
          }

          if (evt.which === KEYS.right) {
            self.next();
          }

          // Update focus on newly selected tab
          if ((evt.which === KEYS.left) || (evt.which === KEYS.right)) {
            $dots.find('.slick-active button').focus();
          }
        });
      }
    },

    next: function() {
      this.$slideshow.slick('slickNext');
    },

    prev: function() {
      this.$slideshow.slick('slickPrev');
    },

    pause: function() {
      this.$slideshow.slick('slickPause');
    },

    play: function() {
      this.$slideshow.slick('slickPlay');
    },

    unpause: function() {
      if (this.settings.autoplay) {
        this.play();
      }
    },

    /**
     * Finds and displays a slide associated with the blockId passed in.
     * Note:  Block IDs are not required on slides for the slideshow to work
     *        If used, the slide element must have the attribute - data-block-id="{{ block.id }}"
     *
     * @param {string} blockId
     */
    goToSlideByBlockId: function(blockId) {
      var slick = this.$slideshow.slick('getSlick');
      var $slide = slick.$slides.filter('[data-block-id="' + blockId + '"]:not(.slick-cloned)');

      this.$slideshow.slick('slickGoTo', $slide.data('slick-index'));
    }
  });

  return Slideshow;

}(jQuery, Modernizr));

/**
 * Slideup
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Slideup
*/

slate.models = slate.models || {};

slate.models.Slideup = (function($, Modernizr) {

  var $document = $(document);

  var selectors = {
    close: '[data-slideup-close]',
  };

  var classes = {
    slideup: 'slideup',
    visible: 'is-visible'
  };

  /**
   * Slideup constructor
   *
   * @param {HTMLElement | $} el - The slideup element
   * @param {Object} options
   */
  function Slideup(el, options) {
    this.name = 'slideup';
    this.namespace = '.' + this.name;

    this.$el = $(el);
    this.stateIsOpen = false;
    this.transitionEndEvent = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if (this.$el == undefined || !this.$el.hasClass(classes.slideup)) {
      console.warn('[' + this.name + '] - Element with class `' + classes.slideup + '` required to initialize.');
      return;
    }

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE: 'hide' + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW: 'show' + this.namespace,
      SHOWN: 'shown' + this.namespace
    };

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));
  }

  Slideup.prototype = $.extend({}, Slideup.prototype, {

    /**
     * Called after the closing animation has run
     */
    onHidden: function() {
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if (!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.$el.removeClass(classes.visible);

      if (this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if (this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if (this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // SLIDEUP DATA-API
  // ===============

  $document.on('click.slideup', '[data-toggle="slideup"]', function(e) {

    var $this = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data = $this.data('slideup');

    if ($this.is('a')) e.preventDefault();

    if (!data) {
      $this.data('slideup', (data = new Slideup($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });

  return Slideup;
}(jQuery, Modernizr));

/**
 * Overlay
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Overlay
*/

slate.models = slate.models || {};

slate.models.Overlay = (function($, Modernizr) {

  var $document = $(document);
  var $body = $(document.body);

  var selectors = {
    close: '[data-overlay-close]'
  };

  var classes = {
    overlay: 'overlay',
    visible: 'is-visible',
    bodyOverlayOpen: 'overlay-open'
  };

  /**
   * Overlay constructor
   *
   * @param {HTMLElement | $} el - The overlay element
   * @param {Object} options
   */
  function Overlay(el, options) {

    this.name = 'overlay';
    this.namespace = '.' + this.name;

    this.$el = $(el);

    this.stateIsOpen = false;
    this.transitionEndEvent = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if (this.$el == undefined || !this.$el.hasClass(classes.overlay)) {
      console.warn('[' + this.name + '] - Element with class `' + classes.overlay + '` required to initialize.');
      return;
    }

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE: 'hide' + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW: 'show' + this.namespace,
      SHOWN: 'shown' + this.namespace,
      FOCUS: 'focus' + this.namespace,
      KEYDOWN_DISMISS: 'keydown.dismiss' + this.namespace
    };

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));
  }

  Overlay.prototype = $.extend({}, Overlay.prototype, {
    /**
     * Called after the closing animation has run
     */
    onHidden: function() {
      $body.removeClass(classes.bodyOverlayOpen);

      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      this.enforceFocus();

      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
      this.$el.trigger('focus');
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if (!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.updateEscapeHandler();

      $document.off(this.events.FOCUS);

      this.$el.removeClass(classes.visible);

      if (this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if (this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.updateEscapeHandler();

      $body.addClass(classes.bodyOverlayOpen);
      this.$el.addClass(classes.visible);

      if (this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    enforceFocus: function() {
      $document.off(this.events.FOCUS);
      $document.on(this.events.FOCUS, $.proxy(function(e) {
        if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$el.trigger('focus');
        }
      }, this));
    },

    updateEscapeHandler: function() {
      if (this.stateIsOpen) {
        this.$el.on(this.events.KEYDOWN_DISMISS, $.proxy(function(e) {
          e.which == 27 && this.hide();
        }, this));
      }
      else {
        this.$el.off(this.events.KEYDOWN_DISMISS);
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // OVERLAY DATA-API
  // ===============

  $document.on('click.overlay', '[data-toggle="overlay"]', function(e) {

    var $this = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data = $this.data('overlay');

    if ($this.is('a')) e.preventDefault();

    if (!data) {
      $this.data('overlay', (data = new Overlay($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });

  return Overlay;
}(jQuery, Modernizr));

/**
 * Model - Collection Filters - Desktop + Mobile
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.collectionFilters
 */

slate.models = slate.models || {};

slate.models.CollectionFilters = (function() {

  var selectors = {
    filterSelect: '[data-filters-type][data-filters-type-select]',
    mobileFilterGroup: '[data-mobile-filter-group]',
    mobileFilterTag: '[data-mobile-filter-tag][data-mobile-filter-type]',
    mobileFilterApply: '[data-mobile-filter-apply]'
  };

  var classes = {
    mobileFilterTagSelected: 'is-selected'
  };

  /**
   * CollectionFilters constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionFilters(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionFilters';
    this.namespace = '.' + this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$filterSelects = $(selectors.filterSelect, this.$container);
    this.$mobileFilterTags = $(selectors.mobileFilterTag, this.$container);

    this.$container.on('change', selectors.filterSelect, this.onFilterSelectChange.bind(this));
    this.$container.on('click', selectors.mobileFilterTag, this.onMobileFilterTagClick.bind(this));
    this.$container.on('click', selectors.mobileFilterApply, this.onMobileFilterApplyClick.bind(this));

    this._sortFilters();
  }

  CollectionFilters.prototype = $.extend({}, CollectionFilters.prototype, {
    /**
     * Returns a url for the current collection with selected tags
     *
     * @return {string} - url
     */
    _getCollectionUrlWithTags: function(tags) {
      var collectionUrl = this.collectionData.url;

      tags = tags || [];

      tags = tags.map(function(str) {
        return str
          .toLowerCase()
          .replace(/[^\w\u00C0-\u024f]+/g, "-")
          .replace(/^-+|-+$/g, "");
      });

      return tags.length ? collectionUrl + '/' + tags.join('+') : collectionUrl;
    },

    _getSelectedTags: function() {
      return $.map(this.$filterSelects.find('option:selected'), function(opt, i) {
        // Make sure we don't push empty strings
        if ($(opt).val()) {
          return $(opt).val();
        }
      });
    },

    _getSelectedMobileTags: function() {
      return $.map(this.$mobileFilterTags, function(tag, i) {
        if ($(tag).hasClass(classes.mobileFilterTagSelected)) {
          return $(tag).data('mobile-filter-tag');
        }
      });
    },

    _sortingFunctions: {

      /**
       * Sorts sizes based on a predefined order
       *
       * @param (string) a
       * @param (string) b
       * @return (int)
       */
      size: function(a, b) {
        console.warn('[collectionFilters] - _sortingFunctions.size - This method hasn\'t been implemented yet.');
        // Implement this so sizes show up how we expect them to? small, med, large..
      }
    },

    /**
     * Sorts the filter options inside each select tag if there is an applicable sort function available
     */
    _sortFilters: function() {
      this.$filterSelects.each(function(index, element) {
        var $select = $(element);
        var $toSort = $select.find('option');
        var sortingFunction = this._sortingFunctions[$select.data('filters-type')];

        if (sortingFunction) {
          $toSort.sort(function(a, b) {
            return sortingFunction($(a).val(), $(b).val());
          });
        }
      }.bind(this));
    },

    /**
     * Redirects the browser to the passed in URL while mainting the query string
     *
     * @param (string) url
     */
    redirect: function(url) {
      window.location.href = url + slate.utils.getQueryString();
    },

    /**
     * Redirects the browser to the collection page without any filters applied
     */
    clear: function() {
      window.location.href = this.collectionData.url + slate.utils.getQueryString();
    },

    /**
     * Applies the selected filter options
     * Looks for selected options and creates a URL for them, then redirects the browser
     *
     * @param (event) e - click event
     */
    onFilterSelectChange: function(e) {
      var selectedTags = this._getSelectedTags();
      var url = this._getCollectionUrlWithTags(selectedTags);

      this.redirect(url);
    },

    /**
     * Toggles the selected class for the clicked on filter tag while removing the selected class from other filter tags in the same group
     *
     * @param (event) e - click event
     */
    onMobileFilterTagClick: function(e) {
      e.preventDefault();

      var $tag = $(e.currentTarget);
      var tagIsSelected = $tag.hasClass(classes.mobileFilterTagSelected);

      $tag.parents(selectors.mobileFilterGroup).find(selectors.mobileFilterTag).removeClass(classes.mobileFilterTagSelected);

      if (!tagIsSelected) {
        $tag.addClass(classes.mobileFilterTagSelected);
      }
    },

    /**
     * Applies the selected mobile filter tags.
     * Looks for selected tags and creates a URL for them, then redirects the browser
     *
     * @param (event) e - click event
     */
    onMobileFilterApplyClick: function(e) {
      e.preventDefault();

      var selectedTags = this._getSelectedMobileTags();
      var url = this._getCollectionUrlWithTags(selectedTags);

      this.redirect(url);
    }
  });

  return CollectionFilters;
})();

/**
 * Model - Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - models.collectionSort
 */

slate.models.CollectionSort = (function() {

  var selectors = {
    sortSelect: '[data-sort-select]'
  };

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.' + this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.sortSelect, this.applySort.bind(this));
  }

  CollectionSort.prototype = $.extend({}, CollectionSort.prototype, {
    applySort: function() {
      var sortBy = $(selectors.sortSelect, this.container).find('option:selected').val();
      var queryParams = slate.utils.getQueryParams();

      if (sortBy !== this.collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }
      else {
        delete queryParams.sort_by;
      }

      location.search = $.param(queryParams);
    }
  });

  return CollectionSort;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.productDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {
    productIdInput: '[data-product-id-recently-viewed]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.settings = {};
    this.name = 'product';
    this.namespace = '.' + this.name;

    this.productDetailForm = new slate.ProductDetailForm({
      $el: this.$container,
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false
    });

    this.productDetailForm.initialize();

    this.addCurrentProductIdToLocalStorage();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Add the currently viewed product's id to local storage
     *
     */
    addCurrentProductIdToLocalStorage: function() {
      // Parse any JSON previously stored in allEntries
      var recentlyViewedProducts = JSON.parse(localStorage.getItem("recently_viewed"));
      if (recentlyViewedProducts == null) recentlyViewedProducts = [];
      var productHandle = $(selectors.productIdInput).val();

      // Check to see if the value is in the array (IE11).
      var inArr = $.inArray(productHandle, recentlyViewedProducts);

      // If the in array is negative (not present), add it. Had to do this
      // way due to IE11 compatibility.
      if (inArr < 0) {
        // If there are five products or more, remove the last element in the arry
        if (recentlyViewedProducts.length >= 5) {
          recentlyViewedProducts.pop();
        }
        // Add current product to products beginning of array
        recentlyViewedProducts.unshift(productHandle);

        // Check to see if there are any undefined array values
        for (let i = 0; i <= recentlyViewedProducts.length; i++) {
          if (typeof recentlyViewedProducts[i] === "undefined") {
            recentlyViewedProducts.splice(i, 1);
          }
        }
      }

      localStorage.setItem("recently_viewed", JSON.stringify(recentlyViewedProducts));
    }
  });

  return Product;
})(jQuery, slate);

/**
 * Article Grid Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - articleGrid
 */

theme.ArticleGrid = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var classes = {
    initialized: '.slick-initialized'
  };

  const $window = $(window);

  /**
   * Article Grid section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function ArticleGrid(container) {
    this.$container = $(container);

    this.name = 'articleGrid';
    this.namespace = '.' + this.name;

    this.$slideshow = $(selectors.slideshow, this.$container);

    this.settings = {
      arrows: true,
      dots: true,
      slidesToShow: 1
    }

    this.init();

    $window.on('breakpointChange', this.onBreakpointChange.bind(this));

    this.slideshow = "";
  }

  ArticleGrid.prototype = $.extend({}, ArticleGrid.prototype, {
    init: function() {
      if ($window.width() < slate.breakpoints.getBreakpointMinWidth('md')) {
        this.slideshow = new slate.models.Slideshow(this.$slideshow, this.settings);
      }
    },

    onBreakpointChange: function(e) {
      var breakpointWidth = e.bpMinWidthKey;

      if (breakpointWidth == 'md' || breakpointWidth == 'lg' || breakpointWidth == 'xl') {
        if (this.$slideshow.is(classes.initialized)) {
          this.$slideshow.slick('unslick');
        }
      } else {
        if (!this.$slideshow.is(classes.initialized)) {
          this.slideshow = new slate.models.Slideshow(this.$slideshow, this.settings);
        }
      }
    }
  });

  return ArticleGrid;
})(jQuery);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.Collection = (function(slate) {

  var selectors = {
    collectionJson: '[data-collection-json]'
  };

  function Collection(container) {
    this.$container = $(container);

    this.name = 'collection';
    this.namespace = '.' + this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      console.warn('[' + this.name + '] - Element matching ' + selectors.collectionJson + ' required.');
      return;
    }

    this.collectionData = JSON.parse($(selectors.collectionJson, this.$container).html());

    this.filters = new slate.models.CollectionFilters(container, this.collectionData);
    this.sort = new slate.models.CollectionSort(container, this.collectionData);
  }

  Collection.prototype = $.extend({}, Collection.prototype, {});

  return Collection;

})(slate);

/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the slideshow on mobile
 *
 * @namespace - pencilBanner
 */

theme.PencilBanner = (function($) {

  var selectors = {
    slideshow: '[data-pencil-banner-slideshow]'
  };

  /**
   * Pencil Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function PencilBanner(container) {
    this.$container = $(container);

    this.name = 'pencilBanner';
    this.namespace = '.' + this.name;

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container));
  }

  PencilBanner.prototype = $.extend({}, PencilBanner.prototype, {});

  return PencilBanner;
})(jQuery);

/**
 * Subscription Slideup Section Script
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.utils
 *  - slate.user
 *  - slate.models.Slideup
 *
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - subscriptionSlideup
 */

theme.SubscriptionSlideup = (function($, slate) {

  var selectors = {
    slideup: '[data-subscription-slideup]',
    formContent: '[data-subscription-slideup-form-content]',
    formMessage: '[data-subscription-slideup-form-message]'
  };

  var classes = {
    showMessage: 'show-message'
  };

  /**
   * Subscription Slideup section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SubscriptionSlideup(container) {
    this.$container = $(container);

    this.name = 'subscriptionSlideup';
    this.namespace = '.' + this.name;

    this.settings = {
      enabled: this.$container.data('enabled'),
      delay: !isNaN(parseInt(this.$container.data('delay'))) ? (parseInt(this.$container.data('delay')) * 1000) : 3000, // delay before showing the modal on pageload,
      seenExpiration: !isNaN(parseInt(this.$container.data('seen-expiration'))) ? parseInt(this.$container.data('seen-expiration')) : 30 // days before showing the modal again
    };

    // if seenExpiration is set to 0, set it to 1 year (very far into the future)
    if (this.settings.seenExpiration == 0) {
      this.settings.seenExpiration = 365;
    }

    // DOM elements we'll need
    this.$el = $(selectors.slideup, this.$container);
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);

    this.slideup = new slate.models.Slideup(this.$el);

    /**
     * These are the cookies that we'll use to keep track of how much the user has seen / interacted with the slideup
     */
    this.cookies = {};

    this.cookies.seen = slate.user.generateCookie('subscriptionSlideupSeen');
    this.cookies.seen.value = slate.utils.hashFromString(this.$el.text()).toString(); // Set the cookie value based on the content
    this.cookies.seen.expiration = this.settings.seenExpiration;

    this.cookies.emailCollected = slate.user.generateCookie('emailCollected');
    this.cookies.emailCollected.expiration = this.settings.seenExpiration;

    /**
     * Attach event handlers
     */
    this.$el.on('hide.slideup', this.onHide.bind(this));
    this.$el.on('hidden.slideup', this.onHidden.bind(this));

    /**
     * Checks the show logic and displays the popup if everything checks out
     */
    if (this.shouldShow()) {
      setTimeout(function() {
        this.slideup.show();
      }.bind(this), this.settings.delay);
    }
  }

  SubscriptionSlideup.prototype = $.extend({}, SubscriptionSlideup.prototype, {
    /**
     * Resets everything to it's initial state.  Only call when slideup isn't visible.
     */
    reset: function() {
      this.$formContent.find('input[type="email"]').val('');
      this.$formMessage.html('');
      this.$formContent.removeClass(classes.showMessage);
    },

    onSubscribeSuccess: function() {
      this.$formMessage.html(this.$formMessage.data('message-success'));
      this.$formContent.addClass(classes.showMessage);

      if (!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }
    },

    onSubmitFail: function() {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function() {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    shouldShow: function() {

      // Checks should be done in this order!

      if (slate.utils.isThemeEditor() || !this.settings.enabled) {
        return false;
      }

      if (slate.user.hasCookie(this.cookies.emailCollected.name)) {
        return false;
      }

      if (slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
        return false;
      }

      return true;
    },

    onHide: function() {
      if (!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }
    },

    onHidden: function() {
      this.reset();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.slideup.show();
    },

    onDeselect: function() {
      this.slideup.hide();
    }
  });

  return SubscriptionSlideup;
})(jQuery, slate);

/**
 * Instagram Feed Section Script
 * ------------------------------------------------------------------------------
 * 
 * Uses Instafeed.js to interact with Instagram API
 *   - See instafeedjs.com for documentation
 *   - See scripts/vendor directory for source file
 *
 * @namespace - instagramFeed
 */

theme.InstagramFeed = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    slide: '.content-grid__item'
  };

  var $window = $(window);

  /**
   * Instagram Feed section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function InstagramFeed(container) {
    this.$container = $(container);

    this.name = 'instagramFeed';
    this.namespace = '.' + this.name;

    this.$slideshow = $(selectors.slideshow, this.$container);

    this.settings = {
      arrows: true,
      dots: true,
      slidesToShow: 1
    }

    this.init();

    $window.on('breakpointChange', this.onBreakpointChange.bind(this));

    this.slideshow = "";
  }

  InstagramFeed.prototype = $.extend({}, InstagramFeed.prototype, {
    init: function() {
      if ($window.width() < slate.breakpoints.getBreakpointMinWidth('sm')) {
        this.slideshow = new slate.models.Slideshow(this.$slideshow, this.settings);
      }
    },
    onBreakpointChange: function(e) {
      var breakpointWidth = e.bpMinWidthKey;

      if (breakpointWidth == 'md' || breakpointWidth == 'lg' || breakpointWidth == 'xl') {
        if (this.$slideshow.is('.slick-initialized')) {
          this.$slideshow.slick('unslick');
        }
      } else {
        if (!this.$slideshow.is('.slick-initialized')) {
          this.slideshow = new slate.models.Slideshow(this.$slideshow, this.settings);
        }
      }
    }
  });

  return InstagramFeed;
})(jQuery);

/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slideshow
 */

theme.Slideshow = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.' + this.name;

    var settings = {
      arrows: false
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return Slideshow;
})(jQuery);

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - header
 */

theme.Header = (function($) {

  var $window = $(window);
  var $body = $(document.body);

  var selectors = {
    header: '[data-header]',
    dropdownTrigger: '[data-dropdown-trigger][data-block]',
    headerPencilPanel: '[data-header-pencil-panel]',
    headerPencilTransitionDelay: 'header-pencil-transition-delay',
    dataSearchBarMobile: '[data-search-bar-mobile]',
    dataSearchClickMobile: '[data-search-click-mobile]',
    dataSearchContainerMobile: '[data-search-container-mobile]',
    mobileIcon: '.header-nav--hide-on-desktop .minimal-input-box__submit',
    autodeliveryPencilBanner: '#autodelivery-pencil-banner'
  };

  var classes = {
    headerFixed: 'is-fixed',
    siteHasFixedHeader: 'site-fixed-header',
    headerHasAutodelivery: 'site-fixed-header--autodelivery'
  };

  function Header(container) {
    this.$container = $(container);

    this.name = 'header';
    this.namespace = '.' + this.name;

    this.$el = $(selectors.header, this.$container);

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    this.dropdownManager = new slate.models.DropdownManager();

    this.$dataSearchBarMobile = $(selectors.dataSearchBarMobile, this.$container);
    this.$dataSearchClickMobile = $(selectors.dataSearchClickMobile, this.container);
    this.$dataSearchContainerMobile = $(selectors.dataSearchContainerMobile, this.container);

    // Register each dropdown trigger
    $(selectors.dropdownTrigger, this.$container).each(function(i, trigger) {
      this.dropdownManager.register($(trigger));
    }.bind(this));

    this.$container.on('pointerleave mouseleave', this.onMouseLeave.bind(this));
    this.$container.on('click', selectors.mobileIcon, this.onSearchClickMobile.bind(this));

    // We pass in the fixed behavior as a class on the body of the site
    if ($body.hasClass(classes.siteHasFixedHeader)) {
      $window.on(this.events.SCROLL, $.throttle(20, this.onScroll.bind(this)));
      this.onScroll(); // hit this one time on init to make sure everything is good
    }

    // Pencil Section
    this.headerPencilBreakpointMin = slate.breakpoints.getBreakpointMinWidth('md');
    this.headerPencilBelowBreakpoint = undefined; // defined in handleHeaderPencilResize
    this.headerPencilDelay = Number(this.$container.data(selectors.headerPencilTransitionDelay)) * 1000;

    this.$headerPencilPanels = $(selectors.headerPencilPanel, this.$container);

    if ($(selectors.autodeliveryPencilBanner).length) {
      $body.addClass(classes.headerHasAutodelivery);
    }

    if (this.$headerPencilPanels.length > 1) {

      this.activePanel = 0; //activePanel property keeps track of which panel is currently displayed.
      this.numberOfPanels = this.$headerPencilPanels.length; //number of total panels

      // Handle mouse events over pencil
      this.$headerPencilPanels.on("mouseover", this.onHeaderPencilMouseover.bind(this));
      this.$headerPencilPanels.on("mouseout", this.onHeaderPencilMouseout.bind(this));

      $(window).on('load resize', this.handleHeaderPencilResize.bind(this));
    }
  }

  Header.prototype = $.extend({}, Header.prototype, {
    initHeaderPencil: function() {
      this.animationInterval = setInterval(function() {
        requestAnimationFrame(this.showNextHeaderPencilPanel.bind(this));
      }.bind(this), this.headerPencilDelay);
    },

    destroyHeaderPencil: function() {
      this.stopHeaderPencil();
      this.$headerPencilPanels.show();
    },

    stopHeaderPencil: function() {
      clearInterval(this.animationInterval);
    },

    onHeaderPencilMouseover: function() {
      this.hasHover = true;
      this.handleHeaderPencilResize();
    },

    onHeaderPencilMouseout: function() {
      this.hasHover = false;
      this.handleHeaderPencilResize();
    },

    showNextHeaderPencilPanel: function() {
      //if the pencil banner doesnt have hover...
      if (!this.hasHover) {
        var nextPanel = this.activePanel + 1 >= this.numberOfPanels ? 0 : this.activePanel + 1;
        this.activePanel = nextPanel;

        $(this.$headerPencilPanels[nextPanel]).show().siblings(selectors.headerPencilPanel).hide(); //show given index, hide all siblings
      }
    },

    handleHeaderPencilResize: function() {
      if (window.innerWidth < this.headerPencilBreakpointMin && !this.headerPencilBelowBreakpoint) {
        this.initHeaderPencil();
        this.headerPencilBelowBreakpoint = true;
      } else if (window.innerWidth >= this.headerPencilBreakpointMin && this.headerPencilBelowBreakpoint) {
        this.destroyHeaderPencil();
        this.headerPencilBelowBreakpoint = false;
      }
    },

    scrollCheck: function() {
      // Do measurements outside of rAF.
      var scrollTop = $window.scrollTop();
      var actualOffset = this.$container.offset()['top'] - this.$el.outerHeight();

      // Do DOM updates inside.
      requestAnimationFrame(function() {
        if (scrollTop < actualOffset) {
          this.$el.removeClass(classes.headerFixed);
        }
        else {
          this.$el.addClass(classes.headerFixed);
        }
      }.bind(this));
    },

    onScroll: function() {
      this.scrollCheck();
    },

    onMouseLeave: function() {
      this.dropdownManager.closeAllDropdowns();
    },

    onBlockDeselect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId(e.detail.blockId);

      // Bypass dropdown manager since we're inside the theme editor
      if (dropdown) {
        dropdown.forceClose();
      }
    },

    onSearchClickMobile: function(e) {
      e.preventDefault();
      if (this.$dataSearchContainerMobile.is(':hidden')) {
        this.$dataSearchContainerMobile.slideDown(function() {
          this.hideOnClickOutside(this.$dataSearchContainerMobile);
          this.$dataSearchBarMobile.focus();
        }.bind(this))
      }
    },

    hideOnClickOutside: function(selector) {
      _this = this;
      function outsideClickListener(event) {
        if (!$(event.target).closest(selector).length) {
          if ($(selector).is(':visible')) {
            _this.$dataSearchBarMobile.focus();
            $(selector).slideUp();
            removeClickListener();
          }
        }
      }

      function removeClickListener() {
        document.removeEventListener('click', outsideClickListener)
      }

      document.addEventListener('click', outsideClickListener)
    },

    /**
     * Theme Editor section events below
     */

    onBlockSelect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId(e.detail.blockId);

      // Bypass dropdown manager since we're inside the theme editor
      if (dropdown) {
        dropdown.forceOpen();
      }
    }
  });

  return Header;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($) {

  var selectors = {
    newsletterSubscribeForm: '[data-newsletter-subscribe-form]'
  };

  function Footer(container) {
    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.' + this.name;

    // var listrakForm = $(selectors.newsletterSubscribeForm, this.$container );
    // this.AjaxListrakForm = new slate.AjaxListrakForm(listrakForm);
  }

  Footer.prototype = $.extend({}, Footer.prototype, {});

  return Footer;
})(jQuery);

/**
 * Ajax Cart Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the interacting with the ajax cart section.
 * All logic is handled in slate.AjaxCart, this file is strictly for handling section settings and them editor interactions
 *
 * @namespace - ajaxCart
 */

theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
      this.namespace = '.' + this.name;

    this.ajaxCart = new slate.AjaxCart();

    if (!$body.hasClass('template-cart')) {
      this.ajaxCart.init();
    }
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {
    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onUnload: function() {
      this.ajaxCart.$backdrop && this.ajaxCart.$backdrop.remove();
    }
  });

  return AjaxCart;
})(jQuery);

/**
 * Cart Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - cart
 */

theme.Cart = (function($, slate) {

  var selectors = {
    form: '[data-cart-form]',
    itemQtySelect: '[data-item-quantity-select]',
    updateOgSubscription: '[data-update-subscription]',
    frequencySelector: '[data-subscription-frequency]',
    label: '[data-option-label]',
    cbdProduct: '[data-cbd-product]',
    additionalCheckoutBtns: '[data-additional-checkout-buttons]'
  };

  function Cart(container) {
    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.' + this.name;

    this.$form = $(selectors.form, this.$container);
    this.updateFreqRateVal;


    // Since we have more than 1 quantity select per row (1 for mobile, 1 for desktop)
    // We need to use single input per row, which is responsible for sending the form data for that line item
    // Watch for changes on the quantity selects, and then update the input.  These two are tied together using a data attribute
    this.$container.on('change', selectors.itemQtySelect, this.onUpdateQuantityToggled.bind(this));
    this.$container.on('click', selectors.updateOgSubscription, this.updateSubscription.bind(this));
    this.$container.on('change', selectors.frequencySelector, this.subscriptionFreqChanged.bind(this));
    this.$container.on('click', selectors.label, function(e) {
      if ($(e.currentTarget).siblings("input[type=radio]:checked").length) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    this.checkCbdProducts();
  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    checkCbdProducts: function() {
      var $cbdProduct = $(selectors.cbdProduct);

      if ($cbdProduct.length > 0) {
        $(selectors.additionalCheckoutBtns).remove();
      }
    },

    onUpdateQuantityToggled: function(e) {
      var $itemQtyInput = $('[id="' + $(e.target).data('item-quantity-select') + '"]'); // Have to do '[id=".."]' instead of '#id' because id is generated using {{ item.key }} which has semi-colons in it - breaks normal id select
      $itemQtyInput.val($(e.target).val());
      this.$form.submit();
    },

    getSellingPlanId: function (e) {
      var variantId = e.target.dataset.updateVariantId;
      var frequency = this.updateFreqRateNumber || e.target.dataset.shippingIntervalFrequency;

      var sellingPlanMapElement = document.querySelector('#og-selling-plan-map-' + variantId + '-' + frequency);
      var sellingPlanId = sellingPlanMapElement ? sellingPlanMapElement.getAttribute("selling-plan-id") : null;
      return sellingPlanId || -1;
    },

    updateSubscription: function (e) {
      var removeData = {
        line: $(e.target).data('line-num'),
        quantity: 0
      };

      var removeSettings = {
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: removeData
      };

      var self = this;
      $.ajax(removeSettings).done(function (response) {
        if (response) {
          if ($(e.target).data('purchase-type') === "onetime") {
            var data = {
              quantity: $(e.target).data('item-quantity'),
              id: $(e.target).data('change-variant-id'),
              purchase_type: $(e.target).data('purchase-type')
            }
          } else {
            var subcriptionVarID = $(e.target).data('change-variant-id');
            var subscriptionFrequency = $(e.target).data('shipping-interval-frequency');

            if (self.updateFreqRateVal != undefined) {
              subscriptionFrequency = self.updateFreqRateVal;
              subcriptionVarID = e.target.dataset.updateVariantId;
            }

            var data = {
              quantity: $(e.target).data('item-quantity'),
              id: subcriptionVarID,
              purchase_type: $(e.target).data('purchase-type'),
              selling_plan: self.getSellingPlanId(e)
            }
          }
          var settings = {
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data
          };

          $.ajax(settings).done(function (result) {
            if (result) {
              window.location.reload();
            }
            console.warn('issue updating cart');
          }).fail(function (xhr) {
            console.warn('error adding new product product type', xhr);
          });
        }
      }).fail(function (xhr) {
        console.warn('error adding removing previous product type', xhr);
      });

    },

    subscriptionFreqChanged: function (e) {
      var self = this;
      var rowNum = $(e.target).data('subscription-frequency');
      var $subscriptionInput = $('[data-update-subscription="' + rowNum + '"]');
      var $selectedOption = $(e.target).children("option:selected");
      self.updateFreqRateVal = $selectedOption.data('shipping-interval-frequency');
      self.updateFreqRateNumber = $(e.target).val();
      $subscriptionInput.trigger('click');
    },
  });

  return Cart;
})(jQuery, slate);

/**
 * Mobile menu Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the mobile menu
 *
 * @namespace - mobileMenu
 */

theme.MobileMenu = (function($) {

  var selectors = {
    toggle: '[data-mobile-menu-toggle]',
    hamburger: '[data-hamburger]',
    menu: '[data-mobile-menu]'
  };

  function MobileMenu(container) {
    this.$container = $(container);

    this.name = 'mobileMenu';
    this.namespace = '.' + this.name;

    this.$el = $(selectors.menu, this.$container);
    this.$toggle = $(selectors.toggle); // Don't scope to this.$container

    this.drawer = new slate.models.Drawer(this.$el);

    this.$toggle.on('click', this.onToggleClick.bind(this));
  }

  MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {
    onToggleClick: function(e) {
      e.preventDefault();

      this.$toggle.find(selectors.hamburger).toggleClass('is-active');
      this.drawer.toggle();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.drawer.show();
    },

    onDeselect: function() {
      this.drawer.hide();
    },

    onUnload: function() {
      this.drawer.$backdrop && this.drawer.$backdrop.remove();
    }
  });

  return MobileMenu;
})(jQuery);

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.Blog = (function ($) {

  var selectors = {
    contentGrid: '.content-grid',
    contentGridItem: '.content-grid__item',
    pagination: '[data-pagination]',
    nextPageLink: '[data-next-page]',
    mobileNavStripRedirectForm: '[data-nav-strip-redirect-form]',
    lazyImages: '.article-card__image'
  };

  var classes = {
    lazyImageIsLoaded: 'is-loaded',
    lazyImageLoaded: 'loaded'
  };

  function Blog(container) {
    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.' + this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));
    this.$container.on('change', selectors.mobileNavStripRedirectForm, this.onNavigationStripFormChange.bind(this));
  }

  Blog.prototype = $.extend({}, Blog.prototype, {
    onNextPageLinkClick: function (e) {
      e.preventDefault();
      var $link = $(e.currentTarget);
      var url = $link.attr('href');
      var moduleName = this.$container.data('module-name');

      $.ajax({
        url: url,
        beforeSend: function () {
          $link.html(theme.strings.loading || 'Loading');
        }
      }).done(function (data) {
        var $dom = $(data);
        if (moduleName == '') {
          var $contentItems = $(selectors.contentGridItem, $dom);
          var $newNextPageLink = $(selectors.nextPageLink, $dom);
        } else {
          var $contentItems = $('[data-module-name=' + moduleName + ']', $dom).find(selectors.contentGridItem);
          var $newNextPageLink = $('[data-module-name=' + moduleName + ']', $dom).find(selectors.nextPageLink);
        }

        $(selectors.contentGrid, this.$container).append($contentItems);

        if ($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        } else {
          $(selectors.pagination, this.$container).remove();
        }

        // Unveil plugin to lazy load article card images
        $(selectors.lazyImages).unveil(200, function () {
          var $img = $(this);
          $img.on('load', function () {
            $img.addClass(classes.lazyImageIsLoaded).addClass(classes.lazyImageLoaded);
          });
        });

      }.bind(this));
    },
    /**
     * Handles form change event on mobile navigation strip
    */
    onNavigationStripFormChange: function (e) {
      var targetUrl = e.target.value;
      window.location.href = targetUrl;
    }
  });

  return Blog;
})(jQuery);

/**
 * Tabbed Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace tabSlideshow
 */

theme.tabSlideshow = (function ($, slate) {

  var selectors = {
    tabSlideshowLink: '[data-tab-link][data-block-id]',
    slideshow: '[data-slideshow]',
    lazyImages: 'img[data-src]'
  };

  var classes = {
    tabLinkActive: 'is-active',
    colTwoGrid: 'content-grid--2-col',
    colFourGrid: 'content-grid--4-col',
    lazyImageLoaded: 'loaded'
  };

  function tabSlideshow(container) {
    this.$container = $(container);

    this.name = 'tabSlideshow';
    this.namespace = '.' + this.name;

    this.$tabSlideshowLinks = $(selectors.tabSlideshowLink, this.$container);

    // Slideshow settings
    var colFourSlideshow = {
      dots: true,
      fade: false,
      prevArrow: '<div class="slick-arrow slick-arrow--tab-nav slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--tab-nav slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
      responsive: [
        {
          breakpoint: slate.breakpoints.getBreakpointMinWidth('md'),
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    };

    var colTwoSlideshow = {
      dots: true,
      fade: false,
      prevArrow: '<div class="slick-arrow slick-arrow--tab-nav slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--tab-nav slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
      responsive: [
        {
          breakpoint: slate.breakpoints.getBreakpointMinWidth('md'),
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    // Properties
    this.tabSlideshows = [];

    // Invoke the slideshow with settings based upon markup classes
    this.$container.find(selectors.slideshow).each(function (i, el) {
      if ($(el).hasClass(classes.colTwoGrid)) {
        var slideshowSettings = colTwoSlideshow;
      } else if ($(el).hasClass(classes.colFourGrid)) {
        var slideshowSettings = colFourSlideshow;
      } else if ($(el).hasClass(classes.colThreeGrid)) {
        var slideshowSettings = colThreeSlideshow;
      } else if ($(el).hasClass(classes.colOneGrid)) {
        var slideshowSettings = colOneSlideshow;
      }
      var slideshow = new slate.models.Slideshow(el, slideshowSettings);
      this.tabSlideshows.push(slideshow);
    }.bind(this));

    // Handle tab clicks outside Slick instance
    this.$container.on('click', selectors.tabSlideshowLink, this.onTabLinkClick.bind(this));
    this.$container.on('shown.bs.tab', selectors.tabSlideshowLink, this.onTabPanelShown.bind(this));

  }

  tabSlideshow.prototype = $.extend({}, tabSlideshow.prototype, {

    /**
     * Handles tab clicks on navigation items
     */
    onTabLinkClick: function (e) {
      e.preventDefault();
      var $link = $(e.currentTarget);

      this.$tabSlideshowLinks.removeClass(classes.tabLinkActive);
      $link.addClass(classes.tabLinkActive);

    },

    /**
     * Catches Bootstrap `shown` event for click on tabs
    */
    onTabPanelShown: function (e) {
      var slideshowId = e.target.getAttribute('aria-controls');
      slideshowId = '#' + slideshowId;
      var $slideshow = $(slideshowId).find('.slick-initialized');
      $($slideshow).slick('refresh');
    },

    /**
     * Theme Editor section events below
     */
    onBlockSelect: function (evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return tabSlideshow;

})(jQuery, slate);

/**
 * Recently Viewed Products Script
 * ------------------------------------------------------------------------------
 *
 * Uses pulls product info from local storage and injects it into the recently viewed product grid
 *
 * @namespace - recentlyViewedProducts
 */

theme.recentlyViewed = (function($) {

  var selectors = {
    recentlyViewedGrid: '[data-recently-viewed-grid]',
    productJson: '[data-product-json]'
  };

  function decodeEntities(encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
  }

  // Contstructor
  function RecentlyViewedProducts(container) {
    this.$container = $(container);

    this.name = 'recentlyViewedProducts';
    this.namespace = '.' + this.name;

    //Selectors
    this.$product = JSON.parse($(selectors.productJson, this.$container).html());
    //Event Listeners

    //Initialization functions
    this.getRecentlyViewedProducts();
  }

  RecentlyViewedProducts.prototype = $.extend({}, RecentlyViewedProducts.prototype, {

    // TODO: add logic to not display items that are in the cart

    getRecentlyViewedProducts: function() {
      // retrieve recently viewed product handles from local storage
      var pageProdutHandle = this.$product.handle;
      var handles = JSON.parse(localStorage.getItem('recently_viewed'));
      var requests = [];

      // loop through handles and assebmle ajax requests to the "recently-viewed" alternate product template
      Array.from(handles).forEach(function(productHandle) {
        if (productHandle != pageProdutHandle) {
          requests.push($.get('/products/' + productHandle + '?view=recently-viewed'));
        }
      });

      if (slate.utils.isThemeEditor()) {
        $(selectors.recentlyViewedGrid).append('Recently viewed functionality is not available inside the theme editor. To view, use a theme preview.');
        return;
      }

      if (requests.length) {

        $.each(requests, function() {
          this.then(function(data) {

            data = JSON.parse(data);
            //make sure that the response we recieve is a product card and skip over it if it's not
            if (data.html.indexOf("data-product-card") > -1 && data.html.indexOf("data-product-card-contents") > -1) {
              var $productCard = $(decodeEntities(data.html));
              $(selectors.recentlyViewedGrid).append($productCard);
            }
          },
            // On Safari, instead of redirection, the request returns a 404, handle it here...
            function() {
              return;
            }
          )
        });
      } else {
        // hide the whole section if there the user hasn't ever visited a pdp or local storage is empty
        $('[data-section-type=recently-viewed]').hide();
      }
    },
  })
  return RecentlyViewedProducts;
})(jQuery);

/**
 * Related Articles Products Script
 * ------------------------------------------------------------------------------
 *
 * Instantiates a slideshow for the Related Articles 
 *
 * @namespace - relatedArticles
 */

theme.RelatedArticles = (function($, slate) {

  var selectors = {
    slideshow: '[data-slideshow]'
  };

  // Contstructor
  function RelatedArticles(container) {
    this.$container = $(container);

    this.name = 'relatedArticles';
    this.namespace = '.' + this.name;

    var settings = {
      dots: true,
      fade: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
      responsive: [
        {
          breakpoint: slate.breakpoints.getBreakpointMinWidth('lg'),
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    }

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
  }

  RelatedArticles.prototype = $.extend({}, RelatedArticles.prototype, {});

  return RelatedArticles;
})(jQuery, slate);

/**
 * ProductDescription Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - productDescription
 */

theme.ProductDescription = (function($) {

  var selectors = {
    tabNavigationLinks: '[data-tab-value]',
    tabNavigationContent: '[data-tab-content]',
    dropdownToggles: '[data-dropdown-toggle]',
    dropdownIconPlus: '[data-icon-plus]',
    dropdownIconMinus: '[data-icon-minus]',
    dropdownContent: '[data-dropdown-content]',
    productDetailsContainer: '[data-product-details-container]',
    highlightsContainer: '[data-highlights-container]',
    highlightsList: '[data-highlights-container] .list-rich-text ul',
    aboutTab: '[data-about-tab]',
    productInfo: '[data-product-info]',
    productFlavor: '[data-product-flavor]',
    productCountry: '[data-product-country]',
    productManufacturer: '[data-product-manufacturer]',
    productIngredients: '[data-product-ingredients]',
    modalContainer: '[data-modal-container]',
    modalDetailTrigger: '[data-modal-detail-trigger]',
    modalDetailBody: '[data-modal-detail-body]',
    productInstructions: '[data-product-instructions]',
    productAnnouncements: '[data-product-announcements]',
    ingredientsDropdown: '[data-ingredients-dropdown]',
    instructionsDropdown: '[data-instructions-dropdown]',
    announcementsDropdown: '[data-announcements-dropdown]'
  };

  var classes = {
    isActive: 'is-active'
  };

  function ProductDescription(container) {
    this.$container = $(container);

    this.name = 'productDescription';
    this.namespace = '.' + this.name;

    this.$tabNavigationLinks = $(selectors.tabNavigationLinks, this.$container);
    this.$tabNavigationContent = $(selectors.tabNavigationContent, this.$container);
    this.$dropdownToggles = $(selectors.dropdownToggles, this.$container);
    this.$productDetailsContainer = $(selectors.productDetailsContainer, this.$container);
    this.$highlightsContainer = $(selectors.highlightsContainer, this.$container);
    this.$highlightsList = $(selectors.highlightsList);
    this.$aboutTab = $(selectors.aboutTab, this.$container);
    this.$productInfo = $(selectors.productInfo, this.$container);
    this.$productFlavor = $(selectors.productFlavor, this.$container);
    this.$productCountry = $(selectors.productCountry, this.$container);
    this.$productManufacturer = $(selectors.productManufacturer, this.$container);
    this.$productIngredients = $(selectors.productIngredients, this.$container);
    this.$modalContainer = $(selectors.modalContainer, this.$container);
    this.$modalDetailTrigger = $(selectors.modalDetailTrigger, this.$container);
    this.$modalDetailBody = $(selectors.modalDetailBody, this.$container);
    this.$productInstructions = $(selectors.productInstructions, this.$container);
    this.$productAnnouncements = $(selectors.productAnnouncements, this.$container);
    this.$ingredientsDropdown = $(selectors.ingredientsDropdown, this.$container);
    this.$instructionsDropdown = $(selectors.instructionsDropdown, this.$container);
    this.$announcementsDropdown = $(selectors.announcementsDropdown, this.$container);

    this.$tabNavigationLinks.on('click', this.onTabClick.bind(this));
    this.$dropdownToggles.on('click', this.onToggleClick.bind(this));

    $(window).on('variantChange', this.onVariantChange.bind(this));
  }

  ProductDescription.prototype = $.extend({}, ProductDescription.prototype, {
    onTabClick: function(e) {
      e.preventDefault();

      var selectedTab = $(e.target).data('tab-value');

      if ($(e.target).hasClass(classes.isActive) !== true) {
        this.$tabNavigationLinks.removeClass(classes.isActive);
        $(e.target).addClass(classes.isActive);
        this.$tabNavigationContent.hide();
        $('div[data-tab-content="' + selectedTab + '"]', this.$container).fadeIn('slow');
      }
    },

    onToggleClick: function(e) {
      e.preventDefault();

      var selectedToggle = $(e.target).data('dropdown-toggle') ?
        $(e.target).data('dropdown-toggle') :
        $(e.target).closest('a').data('dropdown-toggle');

      var $iconPlus = $('[data-icon-plus="' + selectedToggle + '"]');
      var $iconMinus = $('[data-icon-minus="' + selectedToggle + '"]');
      var $selectedDropdownContent = $('[data-dropdown-content="' + selectedToggle + '"]', this.$container);

      if ($selectedDropdownContent.is(":hidden") !== false) {
        $(selectors.dropdownContent, this.$container).hide();
        $(selectors.dropdownIconMinus).hide();
        $(selectors.dropdownIconPlus).css('display', 'flex');
        $iconPlus.hide();
        $iconMinus.css('display', 'flex');
        $selectedDropdownContent.fadeIn('slow');

        setTimeout(function() {
          var headerPosition = $('[data-dropdown-toggle=' + selectedToggle + ']').offset().top;

          var headerHeight = $('.header').outerHeight();
          $("html, body").animate({
            scrollTop: headerPosition - headerHeight - 20
          }, 400);
        }, 300);
      } else {
        $(selectors.dropdownIconMinus).hide();
        $(selectors.dropdownIconPlus).css('display', 'flex');
        $(selectors.dropdownContent, this.$container).hide();
      }
    },

    onVariantChange(evt) {
      var productMetafields = evt.product.metafields;
      var variantMetafields = evt.variant.metafields;

      this.updateVariantHighlights(productMetafields, variantMetafields);
      this.updateAboutTabTitle(productMetafields, variantMetafields);
      this.updateProductDescription(productMetafields, variantMetafields);
    },

    updateVariantHighlights: function(productMetafields, variantMetafields) {
      var highlights = variantMetafields.highlights ? variantMetafields.highlights : productMetafields.highlights;

      if (highlights != "" && highlights != null) {
        var $highlights = $.parseHTML(highlights);
      } else {
        return;
      }

      this.$highlightsList.each((index,el) => $(el).html(''));

      if ($highlights.length > 0) {
        this.$highlightsContainer.each(el => $(el).removeClass('hide'));
      } else {
        this.$highlightsContainer.each(el => $(el).addClass('hide'));
      }

      $.each($highlights, function(index, highlight) {
        if ($(highlight).is('p')) {
          this.$highlightsList.each((index,el) => $(el).append("<li>" + highlight.innerText + "</li>"));
        }
      }.bind(this));
    },

    updateAboutTabTitle: function(productMetafields, variantMetafields) {
      var about_title = variantMetafields.about_title ? variantMetafields.about_title : productMetafields.about_title;

      if (about_title != "" && about_title != null) {
        this.$aboutTab.text(about_title);
      } else {
        this.$aboutTab.text(this.$aboutTab.data('about-default'));
      }
    },

    updateProductDescription: function(productMetafields, variantMetafields) {
      this.resetTabNavigation();
      this.resetTabContent();

      this.updateFlavor(productMetafields, variantMetafields);
      this.updateCountryOfOrigin(productMetafields, variantMetafields);
      this.updateManufacturer(productMetafields, variantMetafields);
      this.updateIngredients(productMetafields, variantMetafields);
      this.updateInstructions(productMetafields, variantMetafields);
      this.updateAnnouncements(productMetafields, variantMetafields);
    },

    resetTabNavigation: function() {
      this.$tabNavigationLinks.each(function(index, element) {
        if ($(element).data('tab-value') === "product_info") {
          $(element).addClass(classes.isActive);
        } else {
          $(element).removeClass(classes.isActive);
        }
      });
    },

    resetTabContent: function() {
      this.$tabNavigationContent.each(function(index, element) {
        if ($(element).data('tab-content') === "product_info") {
          $(element).show();
        } else {
          $(element).hide();
        }
      });
    },

    updateFlavor: function(productMetafields, variantMetafields) {
      var flavor = variantMetafields.flavor ? variantMetafields.flavor : productMetafields.flavor;

      if (flavor != null || flavor != undefined) {
        this.$productFlavor.html(flavor);
        this.$productFlavor.show();
      } else {
        this.$productFlavor.hide();
      }
    },

    updateCountryOfOrigin: function(productMetafields, variantMetafields) {
      var country_of_origin = variantMetafields.country_of_origin ? variantMetafields.country_of_origin : productMetafields.country_of_origin;

      if (country_of_origin != null || country_of_origin != undefined) {
        this.$productCountry.find('span').html(country_of_origin);
        this.$productCountry.show();
      } else {
        this.$productCountry.hide()
      }
    },

    updateManufacturer: function(productMetafields, variantMetafields) {
      var manufacturer = variantMetafields.manufacturer ? variantMetafields.manufacturer : productMetafields.manufacturer;

      if (manufacturer != null || manufacturer != undefined) {
        this.$productManufacturer.find('span').html(manufacturer);
        this.$productManufacturer.show();
      } else {
        this.$productManufacturer.hide()
      }
    },

    updateIngredients: function(productMetafields, variantMetafields) {
      var ingredients = variantMetafields.ingredients ? variantMetafields.ingredients : productMetafields.ingredients;
      var ingredientModalTrigger = variantMetafields.ingredients_modal_trigger ? variantMetafields.ingredients_modal_trigger : productMetafields.ingredients_modal_trigger;
      var ingredientModalContent = variantMetafields.ingredients_modal_content ? variantMetafields.ingredients_modal_content : productMetafields.ingredients_modal_content;

      if (ingredients != null || ingredients != undefined) {
        this.$ingredientsDropdown.show();
        this.$productIngredients.html(ingredients);

        if (ingredientModalContent != undefined) {

          var ingredientModalTrigger = ingredientModalTrigger ? ingredientModalTrigger : "FULL NUTRIENT PROFILE";

          this.$modalDetailTrigger.text(ingredientModalTrigger);
          this.$modalDetailBody.html(ingredientModalContent);
          this.$modalContainer.show();
        } else {
          this.$modalContainer.hide();
        }
        this.showTab("ingredients");
      } else {
        this.hideTab("ingredients");
        this.$ingredientsDropdown.hide();
      }
    },

    updateInstructions: function(productMetafields, variantMetafields) {
      var instructions = variantMetafields.instructions ? variantMetafields.instructions : productMetafields.instructions;

      if (instructions != null || instructions != undefined) {
        this.$instructionsDropdown.show();
        this.$productInstructions.html(instructions);
        this.showTab("instructions");
      } else {
        this.hideTab("instructions");
        this.$instructionsDropdown.hide();
      }
    },

    updateAnnouncements: function(productMetafields, variantMetafields) {
      var announcements = variantMetafields.announcements ? variantMetafields.announcements : productMetafields.announcements;

      if (announcements != undefined || announcements != undefined) {
        this.$announcementsDropdown.show();
        this.$productAnnouncements.html(announcements)
        this.showTab("announcements");
      } else {
        this.hideTab("announcements");
        this.$announcementsDropdown.hide();
      }
    },

    hideTab: function(name) {
      this.$tabNavigationLinks.each(function(index, element) {
        if ($(element).data('tab-value') === name) {
          $(element).hide()
        }
      });
    },

    showTab: function (name) {
      this.$tabNavigationLinks.each(function (index, element) {
        if ($(element).data('tab-value') === name) {
          $(element).show()
        }
      });
    }
  });

  return ProductDescription;
})(jQuery);

/**
 * Product Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Product Slideshow
 */

theme.productSlideshow = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function productSlideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.' + this.name;

    var settings = {
      dots: true,
      fade: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
      responsive: [
        {
          breakpoint: slate.breakpoints.getBreakpointMinWidth('lg'),
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);

  }

  productSlideshow.prototype = $.extend({}, productSlideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return productSlideshow;
})(jQuery);

/**
 * Promo Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - promo
 */

theme.Promo = (function($) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slide: '[data-slideshow-slide]',
    taggedImage: '.promo--tagged-image'
  };

  var $window = $(window);

  function Promo(container) {
    this.$container = $(container);

    this.name = 'promo';
    this.namespace = '.' + this.name;

    this.$slideshow = $(selectors.slideshow);

    if ($(selectors.taggedImage, this.container).length && $window.width() < slate.breakpoints.getBreakpointMinWidth('md')) {
      this.sliderSettings = {
        slidesToShow: 1,
        arrows: true,
        dots: true,
        slides: selectors.slide,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: slate.breakpoints.getBreakpointMinWidth('md'),
            settings: "unslick"
          }
        ]
      }
      this.slideshow = new slate.models.Slideshow(selectors.slideshow, this.sliderSettings);

      $window.on('breakpointChange', this.slickChecker.bind(this));
    }
  }

  Promo.prototype = $.extend({}, Promo.prototype, {
    slickChecker: function(evt) {
      if (evt.bpMinWidthKey == 'lg' || evt.bpMinWidthKey == 'xl' && this.$slideshow.hasClass('slick-initialized')) {
        this.$slideshow.slick('unslick');
      } else if (evt.bpMinWidthKey == 'sm' || evt.bpMinWidthKey == 'md' && !this.$slideshow.hasClass('slick-initialized')) {
        this.slideshow = new slate.models.Slideshow(selectors.slideshow, this.sliderSettings);
      }
    }
  });

  return Promo;
})(jQuery);

/**
 * FAQ Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - faq
 */

theme.faq = (function($) {

  var selectors = {
    mobileNavStripRedirectForm: '[data-nav-strip-redirect-form]'
  };

  function Faq(container) {
    this.$container = $(container);

    this.name = 'cmsPage';
    this.namespace = '.' + this.name;

    // Handlers
    this.$container.on('change', selectors.mobileNavStripRedirectForm, this.onNavigationStripFormChange.bind(this));
  }

  Faq.prototype = $.extend({}, Faq.prototype, {
    /**
     * Handles form change event on mobile navigation strip
    */
    onNavigationStripFormChange: function(e) {
      var targetUrl = e.target.value;
      window.location.href = targetUrl;
    }
  });

  return Faq;

})(jQuery);

/**
 * Content Article Cards Script
 * ------------------------------------------------------------------------------
 *
 * @namespace articleCards
 */

theme.articleCards = (function($) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slide: '[data-slideshow-slide]'
  };

  function articleCards(container) {
    this.$container = $(container);

    this.name = 'articleCards';
    this.namespace = '.' + this.name;

    this.slides = $(selectors.slide, this.$container);

    var dotsLength = $(this.slides).length;

    if (dotsLength > 3) {
      var dotsStatus = true;
    } else {
      var dotsStatus = false;
    }

    if (dotsLength > 1) {
      var dotsStatusMobile = true;
    } else {
      var dotsStatusMobile = false;
    }

    var settings = {
      dots: dotsStatusMobile,
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1091,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: dotsStatus,
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
  }

  articleCards.prototype = $.extend({}, articleCards.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return articleCards;

})(jQuery, slate);

/**
 * Product Grid Tabs Script
 * ------------------------------------------------------------------------------
 *
 * @namespace productGridTabs
 */

theme.productGridTabs = (function ($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    slide: '[data-slideshow-slide]',
    tabLink: '[data-tab-link][data-block-id]',
    mobileNavStripRedirectForm: '[data-nav-strip-redirect-form]',
    lazyImages: 'img[data-src]'
  };

  var classes = {
    tabLinkActive: 'is-active',
    lazyImageLoaded: 'loaded'
  };

  function productGridTabs(container) {
    this.$container = $(container);

    this.name = 'productGridTabs';
    this.namespace = '.' + this.name;

    this.slides = $(selectors.slide, this.$container);

    var dotsLength = $(this.slides).length;

    if (dotsLength > 3) {
      var dotsStatus = true;
    } else {
      var dotsStatus = false;
    }

    if (dotsLength > 1) {
      var dotsStatusMobile = true;
    } else {
      var dotsStatusMobile = false;
    }

    var settings = {
      dots: dotsStatusMobile,
      fade: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1091,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            dots: dotsStatus,
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);

    this.$container.on('click', selectors.tabLink, this.onTabLinkClick.bind(this));
    this.$container.on('change', selectors.mobileNavStripRedirectForm, this.onNavigationStripFormChange.bind(this));
    this.$container.on('shown.bs.tab', selectors.tabLink, this.onTabPanelShown.bind(this));
  }

  productGridTabs.prototype = $.extend({}, productGridTabs.prototype, {
    /**
     * Handles UI state change on tab panels
    */
    onTabLinkClick: function (e) {
      e.preventDefault();
      var $link = $(e.currentTarget);
      var $siblingLinks = $link.parent().siblings().children(selectors.tabLink);

      // Add/Remove styling for link states
      $siblingLinks.removeClass(classes.tabLinkActive);
      $link.addClass(classes.tabLinkActive);
    },

    /**
     * Catches Bootstrap event for click on tabs
    */
    onTabPanelShown: function (e) {
      var slideshowId = e.target.getAttribute('aria-controls');
      slideshowId = '#' + slideshowId;
      var $slideshow = $(slideshowId).find('.slick-initialized');
      $($slideshow).slick('refresh');
    },

    /**
     * Handles form change event on mobile navigation strip
    */
    onNavigationStripFormChange: function (e) {
      var targetUrl = e.target.value;
      window.location.href = targetUrl;
    },

    /**
     * Theme Editor section events below
     */
    onBlockSelect: function (evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return productGridTabs;

})(jQuery, slate);

/**
 * Content Blog Grid Script
 * ------------------------------------------------------------------------------
 *
 * @namespace blogGrid
 */

theme.blogGrid = (function($) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slide: '[data-slideshow-slide]',
    lazyImages: 'img[data-src]'
  };

  function blogGrid(container) {
    this.$container = $(container);

    this.name = 'blogGrid';
    this.namespace = '.' + this.name;

    this.slides = $(selectors.slide, this.$container);

    var dotsLength = $(this.slides).length;

    if (dotsLength > 1) {
      var dotsStatus = true;
    } else {
      var dotsStatus = false;
    }

    var settings = {
      dots: dotsStatus,
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      mobileFirst: true,
      adaptiveHeight: true,
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: 1091,
          settings: {
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
            nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
            dots: dotsStatus,
          }
        }
      ]
    };

    var $slideshow = $(selectors.slideshow, this.$container);

    this.slideshow = new slate.models.Slideshow($slideshow, settings);

  }

  blogGrid.prototype = $.extend({}, blogGrid.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return blogGrid;

})(jQuery, slate);

/**
 * Content Grid Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace contentGrid
 */

theme.contentGrid = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    slide: '.content-grid__item.overlay-card'
  };

  function contentGrid(container) {
    this.$container = $(container);

    this.name = 'contentGrid';
    this.namespace = '.' + this.name;

    this.slides = $(selectors.slide, this.$container);

    var dotsLength = $(this.slides).length;

    if (dotsLength > 1) {
      var dotsStatus = true;
    } else {
      var dotsStatus = false;
    }

    // Slider settings
    this.settings = {
      dots: dotsStatus,
      fade: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="slick-arrow slick-arrow--prev"><span class="arrow arrow--tab-nav arrow--left"><span class="arrow__icon"></span></span></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next"><span class="arrow arrow--tab-nav arrow--right"><span class="arrow__icon"></span></span></div>',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1091,
          settings: 'unslick'
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), this.settings);

    $(window).on('breakpointChange', this.onResize.bind(this));
  }

  contentGrid.prototype = $.extend({}, contentGrid.prototype, {
    initSlideshow: function() {
      this.$slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), this.settings);
    },

    destroySlideshow: function() {
      this.slideshow.$slideshow.slick('unslick');
    },

    onResize: function() {
      if (window.innerWidth <= slate.breakpoints.getBreakpointMinWidth('md') && !$(selectors.slideshow, this.$container).hasClass('slick-initialized')) {
        this.initSlideshow();
      } else {
        this.destroySlideshow();
      }
    },

    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return contentGrid;

})(jQuery, slate);

/**
 * Video Module Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace videoModule
 */

theme.videoModule = (function($) {

  var selectors = {
    video: '[data-video]',
    videoOverlay: '[data-video-overlay]',
    playButton: '[data-video-play]'
  };

  var classes = {
    videoPlaying: 'video-playing'
  };

  function videoModule(container) {

    this.$container = $(container);

    this.name = 'videoModule';
    this.namespace = '.' + this.name;

    this.$video = $(selectors.video, this.$container);
    this.$playButton = $(selectors.playButton, this.$container);
    this.$videoOverlay = $(selectors.videoOverlay, this.$container);

    this.$playButton.on('click', this.onPlayVideo.bind(this));

    var elementWatcher = scrollMonitor.create(this.$video);

    if (!this.$videoOverlay.length) {
      $(window).on('load', this.buildVideo());
    }

    elementWatcher.enterViewport(function() {
      var autoPlay = this.$video.data('autoplay');
      //Makes the video autoplay only once when loading the page
      if (autoPlay === 1) {
        this.$playButton.trigger("click");
        this.$video.data('autoplay', 0);
      }
    }.bind(this));
  }

  videoModule.prototype = $.extend({}, videoModule.prototype, {
    buildVideo: function() {
      if (this.$video.length) {
        var options = {
          id: this.$video.data('video-id')
        };

        this.player = new Vimeo.Player(this.$video, options);
        this.player.on('pause', this.onPauseVideo.bind(this));
      }
    },

    onPlayVideo: function(e) {
      e.preventDefault();

      this.buildVideo();

      var $playButton = $(e.currentTarget);
      var $videoOverlay = $(selectors.videoOverlay, this.$container);

      $playButton.addClass(classes.videoPlaying);
      $videoOverlay.addClass(classes.videoPlaying);
      this.$video.addClass(classes.videoPlaying);

      this.player.play();
    },

    onPauseVideo: function() {

      var $playButton = this.$playButton;
      var $videoOverlay = $(selectors.videoOverlay, this.$container);

      $playButton.removeClass(classes.videoPlaying);
      $videoOverlay.removeClass(classes.videoPlaying);
      this.$video.removeClass(classes.videoPlaying);
      this.player.pause();
    }

  });

  return videoModule;

})(jQuery);

/**
 * More Flavours Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - More Flavours
 */

theme.moreFlavours = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function moreFlavours(container) {
    this.$container = $(container);

    this.name = 'moreFlavours';
    this.namespace = '.' + this.name;

    var settings = {
      dots: true,
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrow: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: slate.breakpoints.getBreakpointMinWidth('lg'),
          settings: "unslick"
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
  }

  moreFlavours.prototype = $.extend({}, moreFlavours.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return moreFlavours;
})(jQuery);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]'
  };

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Customer Account Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the customer account template.
 *
 * @namespace customerAccount
 */

theme.customerAccount = (function() {
  var selectors = {
    mobileNavStripRedirectForm: '[data-nav-strip-redirect-form]'
  };

  // Mobile Redirect Select Form
  var $redirectForm = $(selectors.mobileNavStripRedirectForm);
  $redirectForm.on('change', function(e) {
    var targetUrl = e.target.value;
    window.location.href = targetUrl;
  });

})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the styleguide page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

theme.styleguide = (function() {

  var $body = $(document.body);

  var selectors = {
    dot: '.dot'
  };

  if (!$body.is('.template-page-styles')) {
    return;
  }

  $body.on('click', selectors.dot, function() {
    $(this).toggleClass('is-active');
  });

  $body.on('click', 'a[href="#"]', function() {
    return false;
  });

})();


(function($) {
  var $document = $(document);

  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('product-description', theme.ProductDescription);
  sections.register('product-slideshow', theme.productSlideshow);
  sections.register('collection', theme.Collection);
  sections.register('pencil-banner', theme.PencilBanner);
  sections.register('subscription-modal', theme.SubscriptionModal);
  sections.register('subscription-slideup', theme.SubscriptionSlideup);
  sections.register('instagram-feed', theme.InstagramFeed);
  sections.register('slideshow', theme.Slideshow);
  sections.register('header', theme.Header);
  sections.register('footer', theme.Footer);
  sections.register('ajax-cart', theme.AjaxCart);
  sections.register('cart', theme.Cart);
  sections.register('mobile-menu', theme.MobileMenu);
  sections.register('blog', theme.Blog);
  sections.register('tab-slideshow', theme.tabSlideshow);
  sections.register('recently-viewed', theme.recentlyViewed);
  sections.register('related-articles', theme.RelatedArticles);
  sections.register('faq', theme.faq);
  sections.register('promo', theme.Promo);
  sections.register('content-grid', theme.contentGrid);
  sections.register('article-cards', theme.articleCards);
  sections.register('product-grid-tabs', theme.productGridTabs);
  sections.register('blog-grid', theme.blogGrid);
  sections.register('video', theme.videoModule);
  sections.register('more-flavours', theme.moreFlavours);

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  // Target tables to make them scrollable
  slate.rte.wrapTables({
    $tables: $('.rte table'),
    tableWrapperClass: 'table-responsive'
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply UA classes to the document
  slate.utils.userAgentBodyClass();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.utils.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Chosen JS plugin for select boxes
  slate.utils.chosenSelects();

  // Form event handling / validation
  slate.forms.initialize();

  // Update the product video posters
  slate.utils.refreshVideoPosters();

  // START - Global handler for collapse plugin to add state class for open panels
  var panelIsOpenClass = 'is-open';

  $document.on('show.bs.collapse', '.collapse', function(e) {
    $(e.currentTarget).parents('.panel').addClass(panelIsOpenClass);
  });

  $document.on('hide.bs.collapse', '.collapse', function(e) {
    $(e.currentTarget).parents('.panel').removeClass(panelIsOpenClass);
  });

  $('.collapse.in').each(function() {
    $(this).parents('.panel').addClass(panelIsOpenClass);
  });
  // END - Global handler for collapse plugin to add state class for open panels

}(jQuery));
